/***************************************************************************
 * COPYRIGHT (C) 2013, Rapid7 LLC, Boston, MA, USA.
 * All rights reserved.本書には、Rapid7の機密情報および占有情報
 * を含む、未公開の著作物が記載されています。
 **************************************************************************/

const vulnerabilitiesByCvssScoreLabeling = {
  label: {
    cntHigh: '__percent__ (__value__) 7.0と10',
    cntLow: '__percent__ (__value__) 0と3.9',
    cntMedium: '__percent__ (__value__) 4.0と6.9',
  },
  summary: {
    cntHigh: '__percent__の脆弱性のCVSSスコアが7.0と10の間',
    cntLow: '__percent__の脆弱性のCVSSスコアが0と3.9の間',
    cntMedium: '__percent__の脆弱性のCVSSスコアが4.0と6.9の間',
  },
  value: {
    cntHigh: '__percent__ (__value__) の脆弱性のCVSSスコアが<br/>7.0と10の間',
    cntLow: '__percent__ (__value__) の脆弱性のCVSSスコアが<br/>0と3.9の間',
    cntMedium:
      '__percent__ (__value__) の脆弱性のCVSSスコアが<br/>4.0と6.9の間',
  },
};
const vulnerabilitiesBySeverityLabeling = {
  label: {
    cntCritical: '__percent__ (__value__) 危機的な脆弱性',
    cntModerate: '__percent__ (__value__) 中度な脆弱性',
    cntSevere: '__percent__ (__value__) 深刻な脆弱性',
    cntSeverityUnknown: '__percent__ (__value__) 不明な脆弱性',
  },
  summary: {
    cntCritical: '__percent__の脆弱性が危機的',
    cntModerate: '__percent__の脆弱性が中度',
    cntSevere: '__percent__の脆弱性が深刻',
    cntSeverityUnknown: '__percent__の脆弱性が不明',
  },
  value: {
    cntCritical: '__percent__ (__value__) の脆弱性が危機的',
    cntModerate: '__percent__ (__value__) の脆弱性が中度',
    cntSevere: '__percent__ (__value__) の脆弱性が深刻',
    cntSeverityUnknown: '__percent__ (__value__) の脆弱性が不明',
  },
};

const dayRangeLabels = {
  0: '0～29日間',
  1: '30～59日間',
  2: '60～90日間',
  3: '90日間以上',
};
const severityLabels = {
  0: '$t(moderate)',
  1: '$t(severe)',
  2: '$t(critical)',
};
const cvssScoreLabels = {
  0: '0.1-3.9',
  1: '4.0-6.9',
  2: '7.0-10',
};

/* jshint maxlen: false */
export default {
  translation: {
    acronym: {
      vulnerabilities: '脆弱性',
    },
    active: 'アクティブ',
    activelyExploited: {
      entity: {
        cve: 'CVE',
        dateAdded: '日付を追加',
        description: '説明',
        rationale: '論拠',
        source: 'ソース',
        target: 'ターゲット',
      },
      title: 'Rapid7脅威フィード詳細',
    },
    add: '追加',
    addCard: 'カードを追加',
    addCardTitle: 'カードを追加',
    addDashboard: 'ダッシュボードを追加',
    added: '追加',
    address: 'アドレス',
    addresses: 'アドレス',
    admin: {
      manageFilters: '$t(manage) $t(filters)',
      title: '$t(manage) 要素',
    },
    affects: '影響',
    agent: 'エージェント',
    agentConnectionDetail: 'エージェント接続詳細',
    agentDownloadTitle: 'Rapid7エージェントをダウンロード',
    agentDownloadTitle2: 'エージェントのダウンロード、インストールおよび配備',
    agentID: 'エージェントID',
    agentInstructions:
      '<p>zipファイルをシステムへコピーします。ファイルを解凍します。MSIインストーラーは2つあり、1つは32ビット、もう1つは64ビットのWindowsシステム、さらにはconfig.json、3つのセキュリティファイル（client.key、client.crt、cafile.pem）があります。</p><p>適切なMSIインストーラーを実行して、エージェントをインストールします。デフォルトではエージェントは、c:\\Program Files (x86)\\Rapid7\\Endpointエージェントにインストールされ、セキュリティファイルも自動的にインストールされます。エージェントは、「Rapid7エンドポイントエージェント」として見ることが可能なサービスとしてインストールされます。</p><p>エージェントの操作の一部として、「agent.log」ファイルに情報がログされます。またはこのファイルは、agent.log.1およびagent.log.2へとまとめられます。問題があった場合、これらのログファイルを利用してトラブルシューティングを行う場合があります。</p>',
    agentManagement: 'エージェントの管理',
    agentManagerTitle: 'エージェント',
    agentStatus: 'エージェントステータス',
    agentVersion: 'バージョン',
    agents: 'エージェント',
    agentsCount: '__count__エージェント',
    agentsOldVersion: '古いバージョンを使用する',
    agentsPage: {
      chartTitle: 'オペレーティング・システム別にエージェントがあるアセット',
      summary:
        '__percent__のエージェントがあるアセットが__os__オペレーティング・システムを実行',
    },
    agentsRecentlyAssessed: '最近評価済み',
    alert: 'アラート',
    allCards: 'すべての$t(cardsLabel)',
    and: 'および',
    apply: '適用',
    approvedBy: '承認者',
    architecture: 'アーキテクチャ',
    areYouSure: 'よろしいですか？',
    assessed: '評価済み',
    asset_groups: 'アセット・グループ',
    asset_indefinite: 'アセット',
    asset_plural: '__count__アセット',
    asset_plural_indefinite: 'アセット',
    assetCount: 'アセットカウント',
    assetDetails: {
      contextDrivenRiskScore: 'コンテキスト主導型リスク・スコア',
      fetchFailed: 'アセット検索に失敗しました、後で試行してください。',
      kpi: {
        malware: 'マルウェア・キット',
        operatingSystemFingerprints: 'フィンガープリント',
      },
      rotatedTitle: 'アセット概要を表示',
      save: '保存',
    },
    assetDetailsLabel: 'アセット詳細',
    assetGroup: 'アセット・グループ',
    assetGroups: {
      donutTitle: '最高リスクグループ',
      labels: {
        assets: 'アセット',
      },
      title: '上位の高リスクアセット・グループ',
    },
    assetGroupsLabel: 'アセット・グループ',
    assetLabel: 'アセット',
    assetName: 'アセット名',
    assets: 'アセット',
    assetsAffected: '影響を受けるアセット数',
    assetsByComponent: {
      OS: {
        title: 'OS別のアセット',
      },
      assessmentStatus: {
        title: 'アセスメントステータス別のアセット',
      },
    },
    assetsWithUnknownOS:
      'の$t(assets) が未定義の$t(operatingSystem) 上で実行されています',
    assignTo: '割り当て先',
    assignees: '割り当て先',
    availableDashboard: '利用可能なダッシュボード',
    backToAll: '選択をクリア',
    basicInfo: '基本情報',
    cancel: 'キャンセル',
    cardActions: {
      close: '閉じる',
      noChanges: '保存すべき変更のないカード',
      save: 'カードを保存',
      saveAs: '新規カードを保存',
      saveError:
        'カードアップデートでエラーがありました。もう一度試行してください。',
      savedExistingFilter: 'フィルターがアップデートされました。',
      savedExistingFilterSelection: 'カードがアップデートされました。',
      savedExistingFilterSelectionAndFilterContent:
        'フィルターが保存されカードがアップデートされました。',
      savedExistingFilterToNewCard:
        '既存のフィルターが保存され新規カードに適用されました。',
      savedNewCard: '新規カードが作成されました。',
      savedNewFilterToExistingCard:
        '新規フィルターが保存されカードがアップデートされました。',
      savedNewFilterToNewCard: '新規フィルターが新規カードへと保存されました。',
      savedWithExistingFilter:
        '既存のフィルターとカードがアップデートされました。',
      savedWithNewFilter: 'カードと現在のフィルターが保存されました。',
      unsavedChanges: 'カードに未保存の変更はありません。続行しますか？',
    },
    cardEditModal: {
      errors: {
        titleInUse: 'この名前はすでに使用されています',
        titleRequired: 'カード名は空白であってはなりません',
      },
      placeholder: {
        name: 'カード名',
      },
      title: {
        saveAs: '名前を付けて保存',
      },
    },
    cardLibrary: {
      card: {
        'riskiest-sites': {
          description: '最高リスクのサイト、アセットとそれらの脆弱性',
          name: '最高リスクのサイト',
        },
      },
      category: {
        agents: '$t(agents)',
        assets: '$t(assets)',
        exploitableVulns: '$t(exploitableVulns)',
        kpi: '$t(kpi)',
        remediations: '$t(remediations)',
        risk: '$t(risk)',
        sites: '$t(sites)',
        vulns: '$t(vulns)',
      },
    },
    cardSearch: 'カードの検索',
    cardTemplates: {
      AgentsByOS: {
        description:
          'オペレーティング・システム別に接続エージェントがあるアセットの内訳を示すカード。',
        name: 'オペレーティング・システム別にエージェントがあるアセット',
        summary:
          '__percent__のエージェントがあるアセットが__os__オペレーティング・システムを実行',
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      AssetsByLastScanDate: {
        description:
          '最後のスキャンからの経過時間別にアセット・グループのグラフを示します。',
        label: {
          later: '120日間以上',
          'period 1': '0～30日間',
          'period 2': '30～60日間',
          'period 3': '60～90日間',
          'period 4': '90～120日間',
        },
        name: '最終スキャン日別アセット',
        summary: {
          later: '__percent__のアセットが120日以上前にスキャンされました',
          'period 1': '__percent__のアセットが過去30日間にスキャンされました',
          'period 2': '__percent__のアセットが30～60日前にスキャンされました',
          'period 3': '__percent__のアセットが60～90日前にスキャンされました',
          'period 4': '__percent__のアセットが90～120日前にスキャンされました',
        },
        value: {
          later:
            '__percent__ (__value__) のアセットが120日以上前にスキャンされました',
          'period 1':
            '__percent__ (__value__) のアセットが過去30日間にスキャンされました',
          'period 2':
            '__percent__ (__value__) のアセットが30～60日前にスキャンされました',
          'period 3':
            '__percent__ (__value__) のアセットが60～90日前にスキャンされました',
          'period 4':
            '__percent__ (__value__) のアセットが90～120日前にスキャンされました',
        },
      },
      AssetsByOS: {
        description:
          'オペレーティング・システム別にアセットの内訳を示すカード。',
        name: 'オペレーティング・システム別のアセット',
        summary:
          '__percent__のアセットが__os__オペレーティング・システムを実行',
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      AssetsByTotalScanTime: {
        description:
          'スキャン時間別にグループ化されたアセットのグラフを示します。',
        label: {
          cntScanTime10To20: '10～20分',
          cntScanTime20To30: '20～30分',
          cntScanTime30To40: '30～40日分',
          cntScanTimeGt40: '40分以上',
          cntScanTimeLt10: '0～10分',
        },
        name: 'スキャン時間別のアセット',
        summary: {
          cntScanTime10To20:
            '__percent__のアセットに10～20分間のスキャン時間が必要',
          cntScanTime20To30:
            '__percent__のアセットに20～30分間のスキャン時間が必要',
          cntScanTime30To40:
            '__percent__のアセットに30～40分間のスキャン時間が必要',
          cntScanTimeGt40:
            '__percent__のアセットに40分以上のスキャン時間が必要',
          cntScanTimeLt10:
            '__percent__のアセットに0～10分間のスキャン時間が必要',
        },
        value: {
          cntScanTime10To20:
            '__percent__ (__value__) のアセットに10～20分間のスキャン時間が必要',
          cntScanTime20To30:
            '__percent__ (__value__) のアセットに20～30分間のスキャン時間が必要',
          cntScanTime30To40:
            '__percent__ (__value__) のアセットに30～40分間のスキャン時間が必要',
          cntScanTimeGt40:
            '__percent__ (__value__) のアセットに40分以上のスキャン時間が必要',
          cntScanTimeLt10:
            '__percent__ (__value__) のアセットに0～10分間のスキャン時間が必要',
        },
      },
      AssetsByVulnSeverity: {
        description: '深刻度別にグループ化された脆弱性を持つアセットを示します',
        label: {
          critical: '__percent__ (__value__) 危機的な脆弱性',
          moderate: '__percent__ (__value__) 中度な脆弱性',
          severe: '__percent__ (__value__) 深刻な脆弱性',
          unknown: '__percent__ (__value__) 不明な脆弱性',
        },
        name: '脆弱性深刻度別のアセット',
        summary: {
          critical: '__percent__のアセットに危機的な脆弱性あり',
          moderate: '__percent__のアセットに中度な脆弱性あり',
          severe: '__percent__のアセットに深刻な脆弱性あり',
          unknown: '__percent__のアセットに既知の脆弱性検出なし',
        },
        value: {
          critical: '__percent__ (__value__) のアセットに危機的な脆弱性あり',
          moderate: '__percent__ (__value__) のアセットに中度な脆弱性あり',
          severe: '__percent__ (__value__) のアセットに深刻な脆弱性あり',
          unknown: '__percent__ (__value__) のアセットに既知の脆弱性検出なし',
        },
      },
      AssetsCriticalVuln: {
        description:
          '予期せぬ（CVSSスコア8を超える）危機的なリスク脆弱性があるアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '危機的なリスク脆弱性があるアセット',
        summary: {
          assetCount: '危機的な脆弱性がある',
        },
      },
      AssetsNewlyDiscoveredXDays: {
        description:
          '指定時間枠の環境内で新しく発見されたアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '新たに発見されたアセット',
        summary: {
          assetCount: '新たに発見された脆弱性',
        },
      },
      AssetsWithActivelyExploitedVulnerabilities: {
        description:
          'Rapid7は、Rapid7ラボのHeisenberg Honeypot、インシデントレスポンスアクティビティ、および信頼済みサードパーティーからの情報を利用して、最も危険でアクティブにエクスプロイトされる脆弱性の脅威フィードをキュレートしています。このカードはこれらの脆弱性により影響を受けたアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: 'アクティブターゲット脆弱性があるアセット',
        summary: {
          assetCount: 'アクティブターゲット脆弱性がある',
        },
      },
      AssetsWithDefaultAccountVulns: {
        description:
          'デフォルトアカウント利用度に関連する脆弱性があるアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: 'デフォルトアカウント脆弱性があるアセット',
        summary: {
          assetCount: 'デフォルトアカウント脆弱性がある',
        },
      },
      AssetsWithKnownObsoleteOS: {
        description:
          '既知の陳腐化オペレーティング・システムで現在実行中であるアセットの割合。',
        label: {
          assetCount: '陳腐化オペレーティング・システムがあるアセット',
          otherCount: '残りアセット',
        },
        name: '陳腐化オペレーティング・システムで実行するアセット',
        summary: {
          assetCount: '__percent__のアセットが陳腐化OSで実行',
          otherCount: '__percent__のアセットが陳腐化OSで実行なし',
        },
        value: {
          assetCount:
            '__percent__ (__value__) のアセットに陳腐化オペレーティング・システムあり',
          otherCount: '__percent__ (__value__) の残りアセット',
        },
      },
      ChangeInNumberOfAssets: {
        description:
          '主要パフォーマンスインジケータをモニタリングできるよう、アセットの合計数およびその数の指定期間内における変化を示します。',
        label: {
          totalAssets: 'アセット合計',
        },
        name: 'アセットトレンド合計',
        summary: {
          assetCount: '__value__ (__percent__) 増',
        },
      },
      ContainerCountsCard: {
        description: 'アセットコンテナカウントを示すカード',
        name: 'カウント',
      },
      CredentialSuccessCard: {
        description: '認証が成功しなかったアセットを示します。',
        label: {
          cntCredentialFailure: '__percent__ (__value__) ログイン失敗',
          cntCredentialSuccess: '__percent__ (__value__) ログイン成功',
          cntCredentialUnknown: '__percent__ (__value__) ログイン試行なし',
        },
        name: '認証ステータス別のアセット',
        summary: {
          cntCredentialFailure: '__percent__のアセットがログインに失敗',
          cntCredentialSuccess: '__percent__のアセットがログインに成功',
          cntCredentialUnknown: '__percent__のアセットがログイン試行なし',
        },
        value: {
          cntCredentialFailure:
            '__percent__ (__value__) のアセットがログインに失敗',
          cntCredentialSuccess:
            '__percent__ (__value__) のアセットがログインに成功',
          cntCredentialUnknown:
            '__percent__ (__value__) のアセットがログイン試行なし',
        },
      },
      CredentialSuccessOverTime: {
        description:
          'アセットでの経時的な認証情報の成功／失敗に関する情報とグラフを示すカード',
        label: {
          credentialFailedAssetCount: '$t(failed)',
          credentialSuccessAssetCount: '$t(successful)',
          credentialUnknownAssetCount: '$t(unknown)',
        },
        name: '認証情報経時的成功',
        value: {
          credentialFailedAssetCount:
            '$t(weekOf)<br/>$t(failed) __percent__ (__value__)',
          credentialSuccessAssetCount:
            '$t(weekOf)<br/>$t(successful) __percent__ (__value__)',
          credentialUnknownAssetCount:
            '$t(weekOf)<br/>$t(unknown) __percent__ (__value__)',
        },
        yAxisLabel: '$t(percentOfAssets)',
      },
      ExpiredSSLCertificatesCard: {
        description:
          '現在期限切れのSSL認証がある環境内のアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '期限切れSSL認証があるアセット',
        summary: {
          assetCount: '期限切れSSL認証がある',
        },
      },
      ExpiredVulnExceptionTableComponent: {
        description: '最近期限が切れた環境内の脆弱性の例外を示すカード。',
        name: '最近期限が切れた脆弱性の例外',
      },
      ExpiringSSLCertificatesCard: {
        description:
          '指定の時間枠内に期限切れとなるSSL認証のある環境内のアセットの数を示します。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '期限が近いSSL認証があるアセット',
        summary: {
          assetCount: '期限が近いSSL認証がある',
        },
      },
      ExpiringVulnExceptionTableComponent: {
        description: '期限が近い環境内の脆弱性の例外を示すカード。',
        name: '間もなくの脆弱性の例外の期限',
      },
      ExploitableAssetsBySkillLevel: {
        description:
          '環境内のアセットの内訳を脆弱性のエクスプロイトに必要なスキルレベル別に示します。',
        label: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) 不明のエクスプロイト',
          cntMinSkillLevelRankExpert: '__percent__上級者',
          cntMinSkillLevelRankIntermediate: '__percent__中級者',
          cntMinSkillLevelRankNovice: '__percent__ (__value__) 初心者',
        },
        name: 'スキルレベル別にエクスプロイト可能なアセット',
        summary: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__のアセットに既知のエクスプロイトなし',
          cntMinSkillLevelRankExpert:
            '__percent__のアセットが上級者によりエクスプロイト可能',
          cntMinSkillLevelRankIntermediate:
            '__percent__のアセットが中級スキルによりエクスプロイト可能',
          cntMinSkillLevelRankNovice:
            '__percent__のアセットが初心者によりエクスプロイト可能',
        },
        value: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) のアセットに既知のエクスプロイトなし',
          cntMinSkillLevelRankExpert:
            '__percent__ (__value__) のアセットが上級者によりエクスプロイト可能',
          cntMinSkillLevelRankIntermediate:
            '__percent__ (__value__) のアセットが中級スキルによりエクスプロイト可能',
          cntMinSkillLevelRankNovice:
            '__percent__ (__value__) のアセットが初心者によりエクスプロイト可能',
        },
      },
      ExploitableVulnByCVSSscore: {
        description:
          'CVSSスコア別に環境内のエクスプロイト可能な脆弱性の内訳パーセントが示され、一般的基準で環境のどの部分のリスクが高いかを確認できます。',
        name: 'CVSSスコア別にエクスプロイト可能な脆弱性',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      ExploitableVulnDiscoverByTotalRiskScore: {
        description:
          '総合リスク・スコア別に、高リスクから低リスクの順に、過去90日間に発見されたエクスプロイト可能な脆弱性を示します。',
        name:
          '総合リスク・スコア別の新たに発見されたエクスプロイト可能な脆弱性',
      },
      ExploitableVulnerabilities: {
        description:
          '環境内の脆弱性の合計数および指定時間枠内での数の推移を示すカード。',
        label: {
          count: '$t(vulns)',
        },
        name: 'エクスプロイト可能な脆弱性カウント',
        summary: {
          count: 'エクスプロイト可能な脆弱性',
        },
      },
      ExploitableVulnerabilitiesBySeverity: {
        description:
          '深刻度レベルに環境内のエクスプロイト可能な脆弱性の内訳パーセントを示します。',
        name: '深刻度別にエクスプロイト可能な脆弱性',
        ...vulnerabilitiesBySeverityLabeling,
      },
      ExploitableVulnerabilityAgeByCVSS: {
        description:
          'CVSSスコア別にランクされた環境内のエクスプロイト可能な脆弱性が発見された時期をハイライト表示するカード',
        name: 'CVSSスコア別にエクスプロイト可能な脆弱性発見日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityDiscoveryDateBySeverity: {
        description:
          '深刻度別にランクされた環境内のエクスプロイト可能な脆弱性が発見された時期をハイライト表示するカード',
        name: '深刻度別のエクスプロイト可能な脆弱性発見日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishAgeBySeverity: {
        description:
          '深刻度別の環境内のエクスプロイト可能な脆弱性の公開後経過日数を詳しく示すカード',
        name: '深刻度別のエクスプロイト可能な脆弱性の公開後経過日数',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishDateByCVSS: {
        description:
          'CVSSスコア別のエクスプロイト可能な脆弱性の公開日をリストするカード',
        name: 'CVSSスコア別のエクスプロイト可能な脆弱性の公開日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnsBySkillLevel: {
        description:
          '環境内の脆弱性の内訳をエクスプロイトに必要なスキルレベル別に示します。',
        label: {
          cntExpert: '__percent__上級者',
          cntIntermediate: '__percent__中級者',
          cntNovice: '__percent__ (__value__) 初心者',
          cntSkillUnknown: '__percent__ (__value__) 不明のエクスプロイト',
        },
        name: 'スキルレベル別のエクスプロイト可能な脆弱性',
        summary: {
          cntExpert: '__percent__の脆弱性が上級者によりエクスプロイト可能',
          cntIntermediate:
            '__percent__の脆弱性が中級スキルによりエクスプロイト可能',
          cntNovice: '__percent__の脆弱性が初心者によりエクスプロイト可能',
          cntSkillUnknown: '__percent__の脆弱性に既知のエクスプロイトなし',
        },
        value: {
          cntExpert:
            '__percent__ (__value__) の脆弱性が上級者によりエクスプロイト可能',
          cntIntermediate:
            '__percent__ (__value__) の脆弱性が中級スキルによりエクスプロイト可能',
          cntNovice:
            '__percent__ (__value__) の脆弱性が初心者によりエクスプロイト可能',
          cntSkillUnknown:
            '__percent__ (__value__) の脆弱性に既知のエクスプロイトなし',
        },
      },
      MostCommonExploitableVulnComponent: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的な脆弱性を示すカード。',
        name: '最も一般的なエクスプロイト可能な脆弱性',
      },
      MostCommonExploitedVulnComponent: {
        description:
          'Rapid7は、Rapid7ラボのHeisenberg Honeypot、インシデントレスポンスアクティビティ、および信頼済みサードパーティーからの情報を利用して、最も危険でアクティブにエクスプロイトされる脆弱性の脅威フィードをキュレートしています。このカードは、影響を受けたアセットの数別にランクされた環境内の、これらの脆弱性についての詳細を表示します。',
        name: '最も一般的なアクティブターゲット脆弱性',
      },
      MostCommonExploitsComponent: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的なエクスプロイトを示します。',
        name: '最も一般的なエクスプロイト',
      },
      MostCommonMalwareKitsComponent: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的なマルウェア・キットを示します。',
        name: '最も一般的なマルウェア・キット',
      },
      MostCommonVulnComponent: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的な脆弱性を示します。',
        name: '多数発見された脆弱性',
      },
      NewVsRemediatedVulnerabilities: {
        description:
          '任意の日付以降に改善された脆弱性所見の数と未変更の脆弱性所見の数を比較するカード。',
        label: {
          newFindings: '__percent__ (__value__) 新規脆弱性所見',
          remediatedFindings: '__percent__ (__value__) 改善済み脆弱性所見',
          unchangedFindings: '__percent__ (__value__) 未変更脆弱性所見',
        },
        name: '新規対改善される脆弱性',
        summary: {
          newFindings: '__percent__新規脆弱性所見',
          remediatedFindings: '__percent__改善済み脆弱性所見',
          unchangedFindings: '__percent__未変更脆弱性所見',
        },
        value: {
          newFindings: '__percent__ (__value__) 新規脆弱性所見',
          remediatedFindings: '__percent__ (__value__) 改善済み脆弱性所見',
          unchangedFindings: '__percent__ (__value__) 未変更脆弱性所見',
        },
      },
      NumberOfConnectedAgentsComponent: {
        description: '接続エージェントがある環境内のアセットの数を示すカード。',
        label: {
          assetCount: '$t(assets)',
        },
        name: 'エージェントがあるアセットの数',
        summary: {
          assetCount: '接続エージェントがある',
        },
      },
      ObsoleteSoftwareCard: {
        description:
          'ネットワーク上の陳腐化／非陳腐化アセットを詳しく説明するカード。',
        label: {
          assetCount: '陳腐化ソフトウェアがあるアセット',
          otherCount: '残りアセット',
        },
        name: '陳腐化ソフトウェアを実行するアセット',
        summary: {
          assetCount:
            '__percent__のアセットに既知の陳腐化ソフトウェアのインストールあり',
          otherCount:
            '__percent__のアセットに既知の陳腐化ソフトウェアのインストールなし',
        },
        value: {
          assetCount:
            '__percent__ (__value__) のアセットに既知の陳腐化<br/>ソフトウェアのインストールあり',
          otherCount:
            '__percent__ (__value__) のアセットに既知の<br/> 陳腐化ソフトウェアのインストールなし',
        },
      },
      ProjectsAtRiskCard: {
        description:
          '期日が近くオープンのままであるプロジェクトの数を示します。',
        label: {
          totalElements: 'プロジェクトクローズ中',
        },
        name: 'リスクにさらされているプロジェクト',
        summary: {
          totalElements: '',
        },
      },
      ProjectsMostRemainingWorkCard: {
        description: '未解決の改善項目数が多いプロジェクトがリストされます。',
        name: '残り作業',
      },
      ProjectsMostRemainingWorkPercentCard: {
        description: '未解決の改善項目数が多いプロジェクトがリストされます。',
        name: '残り作業%',
      },
      ProjectsPastDueCard: {
        description: '期限が過ぎているプロジェクトの数を示します。',
        label: {
          totalElements: '$t(projects)',
        },
        name: '期限超過プロジェクト',
        summary: {
          totalElements: 'は期限を過ぎています',
        },
      },
      ProjectsRecentlyClosedCard: {
        description: '最近クローズされたプロジェクトの数を示します。',
        label: {
          totalElements: 'プロジェクトクローズド',
        },
        name: '最近のクローズドプロジェクト',
        summary: {
          totalElements: '',
        },
      },
      RemediatedVulnerabilities: {
        description:
          '過去30日以内に環境内で存在数が減少した脆弱性をリストします。',
        name: '上位の改善済み脆弱性',
      },
      RemediatorsRequiringAssistance: {
        description:
          'オープンのままで期限が過ぎているプロジェクトが多いプロジェクト所有者をリストします。',
        name: '支援が必要な改善実施者',
      },
      RiskVulnsCard: {
        description:
          'リスク別や脆弱性数別でアセットを並べた散布プロット図を示します',
        name: 'リスクおよび脆弱性別のアセット',
        summary: {
          selected: 'ホスト名: __name__',
        },
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      TopRemediators: {
        description:
          '期限までに正常にクローズしたプロジェクトが多いプロジェクト所有者をリストします。',
        name: '上位の改善実施者',
      },
      TopRiskiestAssetGroupsComponent: {
        description:
          '環境内でリスク・スコアが最も高いアセット・グループをリストします。',
        name: '上位の高リスクアセット・グループ',
      },
      TopRiskiestAssetLocationsComponent: {
        description: '環境内で総合リスクが最も高いロケーションをリストします。',
        name: '上位の高リスクアセット・ロケーション',
      },
      TopRiskiestAssetOwnersComponent: {
        description:
          '最も総合リスクが高いアセットを持つアセット所有者をリストします。',
        name: '上位の高リスクアセット所有者',
      },
      TopRiskiestAssetsComponent: {
        description: '環境内で最も高リスクなアセットをリストします。',
        name: '上位の高リスクアセット',
      },
      TopRiskiestSitesComponent: {
        description: '環境内で総合リスクが最も高いサイトをリストします。',
        name: '上位の高リスクサイト',
      },
      TotalVulnerabilities: {
        description: '選択した期間中の環境内の脆弱性の数の変化を示すカード。',
        label: {
          count: '$t(vulns)',
        },
        name: '脆弱性の数',
        summary: {
          count: '脆弱性合計',
        },
      },
      TrendingVulnerabilities: {
        description:
          '過去30日以内に環境内で最も見られるようになった脆弱性をリストします。',
        name: '上位のトレンド脆弱性',
      },
      VulnByCVSSscore: {
        description:
          'CVSSスコア別に環境内の脆弱性の内訳パーセントが示され、一般的基準で環境のどの部分のリスクが高いかを確認できます。',
        name: 'CVSSスコア別の脆弱性',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      VulnDiscoverByTotalRiskScore: {
        description:
          '総合リスク・スコア別に、高リスクから低リスクの順に、過去90日間に発見された脆弱性を示します。',
        name: '総合リスク・スコア別の新たに発見された脆弱性',
      },
      VulnRiskOverTime: {
        description:
          '環境内の脆弱性リスクのトレンドが示され、総合リスクの経時的な増減を確認できます。',
        name: '経時的な脆弱性リスク・スコア',
        value: {
          riskScore: '$t(weekOf)<br/>$t(riskScoreLabel) __value__',
        },
        yAxisLabel: '$t(riskScoreLabel)',
      },
      VulnTrends: {
        description: '経時的脆弱性トレンドを示すカード。',
        label: {
          cntCritical: '$t(critical)',
          cntModerate: '$t(moderate)',
          cntSevere: '$t(severe)',
        },
        name: '経時的脆弱性深刻度別のアセット',
        value: {
          cntCritical: '$t(weekOf)<br/>$t(critical) __percent__ (__value__)',
          cntModerate: '$t(weekOf)<br/>$t(moderate) __percent__ (__value__)',
          cntSevere: '$t(weekOf)<br/>$t(severe) __percent__ (__value__)',
        },
      },
      VulnerabilitiesBySeverity: {
        description: '深刻度レベルに環境内の脆弱性の内訳パーセントを示します。',
        name: '危険度別の脆弱性数',
        ...vulnerabilitiesBySeverityLabeling,
      },
      VulnerabilityAgeByCVSS: {
        description:
          'CVSSスコア別にランクされた環境内の脆弱性が発見された時期をハイライト表示するカード',
        name: 'CVSSスコア別の脆弱性発見日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityDiscoveryDateBySeverity: {
        description:
          '深刻度別にランクされた環境内の脆弱性が発見された時期をハイライト表示するカード',
        name: '深刻度別の脆弱性発見日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishAgeBySeverity: {
        description:
          '深刻度別の環境内の脆弱性の公開後経過日数を詳しく示すカード',
        name: '深刻度別の脆弱性公開後経過日数',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishDateByCVSS: {
        description: 'CVSSスコア別に脆弱性の公開日をリストするカード',
        name: 'CVSSスコア別の脆弱性公開日',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      'petya-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title)Petyaに脆弱',
        name: 'Petyaに脆弱な$t(assetsByComponent.OS.title)',
        summary:
          '__percent__のアセットが__os__オペレーティング・システムを実行',
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      'petya-AssetsCriticalVuln': {
        description: 'Petya脆弱性がある環境内のアセットの数',
        label: {assetCount: '$t(assets)'},
        name: 'Petya脆弱性があるアセット',
        summary: {assetCount: 'Petya脆弱性がある'},
      },
      'petya-MostCommonExploitsComponent': {
        description: '環境内のPetyaの$t(cards.mostCommonExploits.title)',
        name: 'Petyaの$t(cards.mostCommonExploits.title)',
      },
      'petya-MostCommonVulnComponent': {
        description: '環境内で最も一般的なPetya脆弱性です。',
        name: '最も一般的なPetya脆弱性',
      },
      'petya-TotalVulnerabilities': {
        description: '環境内のPetya脆弱性所見の数',
        label: {count: 'Petya脆弱性カウント'},
        name: 'Petya脆弱性カウント',
        summary: {count: ''},
      },
      'samba-AssetsByOS': {
        description:
          '$t(cards.assets.card.byOS.title) $t(sambaWithCve) が環境内で見つかりました',
        name: '$t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        summary:
          '__percent__のアセットが__os__オペレーティング・システムを実行',
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      'samba-ChangeInNumberOfAssets': {
        description: '$t(samba) に脆弱なアセット',
        label: {
          totalAssets: 'Sambaに脆弱なアセット',
        },
        name: 'アセット$t(sambaWithCve)',
        summary: {
          assetCount: '__value__ (__percent__) 増',
        },
      },
      'samba-MostCommonExploitsComponent': {
        description: '$t(sambaWithCve) の$t(cards.mostCommonExploits.title) ',
        name: '$t(cards.mostCommonExploits.title) for $t(samba)',
      },
      'samba-TopRiskiestAssetsComponent': {
        description:
          '$t(samba) に脆弱な $t(cards.TopRiskiestAssetsComponent.name) ',
        name:
          '$t(cardTemplates.TopRiskiestAssetsComponent.name) $t(sambaWithCve)',
      },
      'samba-TotalVulnerabilities': {
        description: '環境内の$t(samba) 所見の数',
        label: {count: '$t(samba) $t(vulnerabilities)'},
        name: '$t(samba) 所見の数',
        summary: {count: ''},
      },
      'wannacry-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title)WannaCryに脆弱',
        name: 'WannaCryに脆弱な$t(assetsByComponent.OS.title)',
        summary:
          '__percent__のアセットが__os__オペレーティング・システムを実行',
        value:
          '__percent__ (__value__) のアセットが__os__オペレーティング・システムを実行',
      },
      'wannacry-AssetsCriticalVuln': {
        description: 'WannaCry脆弱性がある環境内のアセットの数',
        label: {assetCount: '$t(assets)'},
        name: 'WannaCry脆弱性があるアセット',
        summary: {assetCount: 'WannaCry脆弱性がある'},
      },
      'wannacry-MostCommonExploitsComponent': {
        description: '環境内のWannaCryの$t(cards.mostCommonExploits.title)',
        name: 'WannaCryの$t(cards.mostCommonExploits.title)',
      },
      'wannacry-MostCommonVulnComponent': {
        description: '環境内で最も一般的なWannaCry脆弱性です。',
        name: '最も一般的なWannaCry脆弱性',
      },
      'wannacry-TotalVulnerabilities': {
        description: '環境内のWannaCry脆弱性所見の数。',
        label: {count: 'WannaCry脆弱性所見'},
        name: 'WannaCry脆弱性のカウント',
        summary: {count: ''},
      },
    },
    cards: {
      assets: {
        card: {
          agents: {
            byOS: {
              description:
                'オペレーティング・システム別に接続エージェントがあるアセットの内訳を示すカード。',
              summary:
                'のエージェントがあるアセットが__os__オペレーティング・システムを実行',
              title: 'オペレーティング・システム別にエージェントがあるアセット',
            },
            comingSoon: '近日提供',
            couldNotDownload:
              'エージェントソフトウェアのダウンロード中にエラーがありました。',
            downloadBtnLoading: 'ダウンロード中：',
            downloadLinuxText: 'Linuxエージェントをダウンロード',
            downloadMacText: 'Macエージェントをダウンロード',
            downloadPageCategory: 'エージェント管理',
            downloadPageTitle: 'エージェントダウンロードおよび管理ページ',
            downloadWindowsText: 'Windowsエージェントをダウンロード',
            featureOne: {
              desc: 'Rapid7エージェントはその他のRapid7製品を統合します。',
              number: '1',
              title: '1つのエージェントがすべてを統べる',
            },
            featureThree: {
              desc:
                '軽量および巧妙に設計されており、ユーザーがエージェントに気付くことは決してありません。',
              number: '3',
              title: 'フットプリントを制限',
            },
            featureTwo: {
              desc:
                '箱から出してすぐに、いつでもオンラインでユーザーと同期する、意義あるデータを得ましょう。',
              number: '2',
              title: '必要な時にデータ処理',
            },
            installInstructions: {
              installation: 'インストール',
              installsTo: 'エージェントのインストール目的：',
              linux: {
                install: './agent_installer.sh install_start',
                installsTo1: '/opt/rapid7/ir_agent/',
                installsTo2:
                  'エージェントは、プラットフォームのSCM（systemctl、systemd、など）またはインストーラー:',
                installsTo3:
                  './agent_installer.shステータスのいずれか制御可能です',
                uninstall: './agent_installer.sh uninstall',
              },
              localInstallation: 'ローカルインストール',
              mac: {
                install: '.pkgをダブルクリックしてUIインストーラーを介します。',
                installsTo: '/opt/rapid7/ir_agent/',
                installsTo2:
                  'エージェントはlaunchctlを介してcom.rapid7.ir_agentとして制御可能です。',
                silentInstall: 'sudoインストーラー -pkg <.pkg> - ターゲット／',
                uninstall: 'sudo /opt/rapid7/ir_agent/uninstall.sh -f',
              },
              multipleInstallations: '複数インストール',
              silentInstall: 'サイレントインストール',
              silentLocalInstall: 'サイレントローカルインストール',
              uninstall: 'アンインストール',
              win: {
                installsTo: 'C:\\Program Files\\Rapid7\\Endpoint Agent\\',
                installsTo2:
                  'エージェントは‘Rapid7エンドポイントエージェント’のサービスを利用して制御可能です。',
                local: '.msiをダブルクリックしてUIインストーラーを介します。',
                multiple:
                  '複数アセットにエージェントをインストールするには、システムセンター設定マネージャー（SCM）などのエンドポイント管理ツールを利用します。グループポリシーオブジェクト（GPO）を利用するには、MSIインストーラーをネットワークログオン共有（アクティブディレクトリ）に設置します。新規GPOを作成します。',
                silentLocal: 'msiexec /i agentinstaller-x86_x64.msi /quiet /qn',
              },
            },
            linuxAgent: 'Linuxエージェント',
            macAgent: 'Macエージェント',
            numberConnected: {
              description:
                '接続エージェントがある環境内のアセットの数を示すカード。',
              subTitle: 'アセット',
              summary: '接続エージェントがある',
              title: 'エージェントがあるアセットの数',
            },
            supportText:
              'ヘルプが必要な場合 <a class="support-link">カスタマー・サポート</a>までご連絡ください。',
            winAgent: 'Windowsエージェント',
          },
          byLastScanDate: {
            description:
              '最後のスキャンからの経過時間別にアセット・グループのグラフを示します。',
            scanDateIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: 'のアセットが__days__日間スキャンなし。',
            title: '最終スキャン日別アセット',
            totalAssets: 'スキャンしたアセット',
          },
          byOS: {
            description:
              'オペレーティング・システム別にアセットの内訳を示すカード。',
            summary: 'のアセットが__os__オペレーティング・システムを実行',
            title: 'オペレーティング・システム別のアセット',
            unknownOS: '不明OS',
          },
          byRiskDelta: {
            description:
              'リスク・スコアが最も高い環境内のアセットをハイライト表示するカード。',
            title: '30日間リスク増加度別のアセット',
          },
          bySkillLevel: {
            description:
              '環境内のアセットの内訳を脆弱性のエクスプロイトに必要なスキルレベル別に示します。',
            expertSummary: 'の環境内のアセットが上級者によりエクスプロイト可能',
            intermediateSummary:
              'の環境内のアセットが中級者によりエクスプロイト可能',
            legend: {
              expert: '上級者',
              intermediate: '中級者',
              novice: '初心者',
              unknown: '既知のエクスプロイトなし',
            },
            noviceSummary: 'の環境内のアセットが初心者によりエクスプロイト可能',
            title: 'スキルレベル別にエクスプロイト可能なアセット',
            unknownSummary: 'の環境内のアセットに既知のエクスプロイトなし',
          },
          byTotalScanTime: {
            description:
              'スキャン時間別にグループ化されたアセットのグラフを示します。',
            scannedIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: 'のアセットに__mins__分間のスキャン時間が必要。',
            title: 'スキャン時間別のアセット',
            totalAssets: 'スキャンしたアセット',
            totalScanTime: 'スキャン時間合計',
          },
          byVulnSeverity: {
            criticalSummary: 'のアセットに危機的な脆弱性あり',
            description:
              '深刻度別にグループ化された脆弱性を持つアセットを示します',
            legend: {
              critical: '危機的な脆弱性',
              moderate: '中度な脆弱性',
              severe: '深刻な脆弱性',
              unknown: '不明な脆弱性',
            },
            moderateSummary: 'のアセットに中度な脆弱性あり',
            severeSummary: 'のアセットに深刻な脆弱性あり',
            title: '脆弱性深刻度別のアセット',
            unknownSummary: 'のアセットに既知の脆弱性検出なし',
          },
          changeInNumber: {
            description:
              '主要パフォーマンスインジケータをモニタリングできるよう、アセットの合計数およびその数の指定期間内における変化を示します。',
            subTitle: 'アセット合計',
            summary: ' __difference__（__percentDifference__%変更）',
            title: 'アセットトレンド合計',
          },
          defaultAccountVulns: {
            description:
              'デフォルトアカウント利用度に関連する脆弱性があるアセットの数を示します。',
            subTitle: 'アセット',
            summary: 'デフォルトアカウント脆弱性がある',
            title: 'デフォルトアカウント脆弱性があるアセット',
          },
          knownObsoleteOS: {
            description:
              '既知の陳腐化オペレーティング・システムで現在実行中であるアセットの割合。',
            subTitle: '陳腐化OSで実行するアセット',
            title: '陳腐化オペレーティング・システムで実行するアセット',
          },
          notScanned: {
            description:
              '指定期間中にスキャンされていないアセットの数を示します。',
            subTitle: 'アセット',
            summary: '未スキャン',
            title: '最近スキャンされていないアセット',
          },
          owners: {
            violatingPolicy: {
              description:
                '会社ポリシーに違反する最大アセット数に関連する所有者。',
              title: '会社ポリシー違反上位のアセット所有者',
            },
          },
          violatingPolicy: {
            description:
              '会社ポリシーに違反する最大アセット数を持つロケーション。',
            title: '会社ポリシー違反上位のアセットロケーション',
          },
        },
        description: '環境内で最も高リスクなアセットをリストします。',
        donutTitle: '最高リスクアセット',
        drilldown: {
          remediation: {
            assigneesPlaceholder: 'プロジェクトを...に割り当て',
            clickHereToViewNewProject:
              'ここをクリックすると、新規プロジェクトを表示できます。',
            createDynamicProject: '動的改善プロジェクトを作成',
            createDynamicProjectHint:
              'フィルターにより定義される新規プロジェクトを作成',
            createStaticProject: '静的改善プロジェクトを作成',
            createStaticProjectHint:
              '選択したアセットを追加して静的プロジェクトを作成',
            descriptionPlaceholder: 'プロジェクトの説明',
            errorNotification:
              '改善プロジェクトの保存のエラーが発生しました、後で再試行してください。',
            manageProjects: 'プロジェクトを管理',
            remediate: '改善',
            selectedCount: '__count__記録を選択。',
            successNotification:
              '改善プロジェクト__title__が正常に作成されました。__link__。',
            titlePlaceholder: 'プロジェクトの名前',
            titleRequired: 'タイトルは空値であってはなりません',
          },
        },
        newlyDiscovered: {
          description:
            '指定時間枠の環境内で新しく発見されたアセットの数を示します。',
          subTitle: 'アセット',
          summary: '新たに発見された脆弱性',
          title: '新たに発見されたアセット',
        },
        title: '上位の高リスクアセット',
        vulnerabilities: {
          critical: {
            description:
              '予期せぬ（CVSSスコア8を超える）危機的なリスク脆弱性があるアセットの数を示します。',
            subTitle: 'アセット',
            summary: '危機的な脆弱性がある',
            title: '危機的なリスク脆弱性があるアセット',
          },
          dataFetchFailed: '脆弱性の検索に失敗しました、後で試行してください。',
          nonCritical: {
            summary: 'のアセットに危機的なリスク脆弱性なし',
          },
        },
      },
      counts: {
        assetGroupsCount: 'アセット・グループ',
        assetSitesCount: 'サイト',
        assetTagsCount: 'タグ',
      },
      credential: {
        'success-over-time': '認証情報経時的成功',
        successCard: {
          chart: {
            credentialFailedAssetCount: 'のアセットがログインに失敗',
            credentialSuccessAssetCount: 'のアセットがログインに成功',
            credentialUnknownAssetCount: 'のアセットがログイン試行なし',
            legend: {
              credentialFailedAssetCount: 'ログイン失敗',
              credentialSuccessAssetCount: 'ログイン成功',
              credentialUnknownAssetCount: 'ログ試行なし',
            },
          },
          description:
            'ネットワーク上の認証情報の成功／失敗率を詳しく示すカード。',
          summary: {
            credentialFailedAssetCount: 'のアセットがログインに失敗',
            credentialSuccessAssetCount: 'のアセットがログインに成功',
            credentialUnknownAssetCount: 'のアセットがログイン試行なし',
          },
          title: 'アセットの認証ステータス',
        },
      },
      'credential-success': {
        description: '認証が成功しなかったアセットを示します。',
        name: '認証ステータス別のアセット',
      },
      'credential-success-over-time': {
        description:
          'アセットでの経時的な認証情報の成功／失敗に関する情報とグラフを示すカード',
        name: '認証情報経時的成功',
      },
      expired: {
        ssl: {
          certificatesCard: {
            description:
              '現在期限切れのSSL認証がある環境内のアセットの数を示します。',
            subTitle: 'アセット',
            summary: '期限切れSSL認証がある',
            title: '期限切れSSL認証があるアセット',
          },
        },
      },
      expiredVulnException: {
        description: '最近期限が切れた環境内の脆弱性の例外を示すカード。',
        title: '最近期限が切れた脆弱性の例外',
      },
      expiring: {
        ssl: {
          certificatesCard: {
            description:
              '指定の時間枠内に期限切れとなるSSL認証のある環境内のアセットの数を示します。',
            subTitle: 'アセット',
            summary: '期限が近いSSL認証がある',
            title: '期限が近いSSL認証があるアセット',
          },
        },
      },
      expiringVulnException: {
        description: '期限が近い環境内の脆弱性の例外を示すカード。',
        title: '間もなくの脆弱性の例外の期限',
      },
      exploitableVulnByCVSSScore: {
        description:
          'CVSSスコア別に環境内のエクスプロイト可能な脆弱性の内訳パーセントが示され、一般的基準で環境のどの部分のリスクが高いかを確認できます。',
        legend: '__from__-__to__',
        summary:
          'のエクスプロイト可能な脆弱性のCVSSスコアが__from__と__to__との間',
        title: 'CVSSスコア別にエクスプロイト可能な脆弱性',
      },
      location: {
        description: '環境内で総合リスクが最も高いロケーションをリストします。',
        title: '上位の高リスクアセット・ロケーション',
      },
      mostCommonExploitableVuln: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的な脆弱性を示すカード。',
        title: '最も一般的なエクスプロイト可能な脆弱性',
      },
      mostCommonExploits: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的なエクスプロイトを示します。',
        title: '最も一般的なエクスプロイト',
      },
      mostCommonMalwareKits: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的なマルウェア・キットを示します。',
        title: '最も一般的なマルウェア・キット',
      },
      mostCommonVuln: {
        description:
          '影響を受けたアセットの数に基づき環境内で最も一般的な脆弱性を示します。',
        title: '多数発見された脆弱性',
      },
      obsolete: {
        osCard: {
          chart: {
            assetCount: '陳腐化OSアセット',
            totalAssets: '残りアセット',
          },
          description:
            '既知の陳腐化オペレーティング・システムで現在実行中であるアセットの割合。',
          summary: {
            nonObsolete: 'のアセットが非陳腐化OSで実行',
            obsolete: 'のアセットが陳腐化OSで実行',
          },
          title: '陳腐化オペレーティング・システムで実行するアセット',
        },
        softwareCard: {
          chart: {
            assetCount: '陳腐化ソフトウェアアセット',
            totalAssets: '残りアセット',
          },
          description:
            'ネットワーク上の陳腐化／非陳腐化アセットを詳しく説明するカード。',
          summary: {
            nonObsolete:
              'のアセットに既知の陳腐化ソフトウェアのインストールなし',
            obsolete: 'のアセットに既知の陳腐化ソフトウェアのインストールあり',
          },
          title: '陳腐化ソフトウェアを実行するアセット',
        },
      },
      owner: {
        description:
          '最も総合リスクが高いアセットを持つアセット所有者をリストします。',
        title: '上位の高リスクアセット所有者',
      },
      projectsAtRisk: {
        description:
          '期日が近くオープンのままであるプロジェクトの数を示します。',
        subTitle: 'プロジェクトクローズ中',
        summary: '',
        title: 'リスクにさらされているプロジェクト',
      },
      projectsMostRemainingWork: {
        description: '未解決の改善項目数が多いプロジェクトがリストされます。',
        title: '残り作業',
      },
      projectsMostRemainingWorkPercent: {
        description: '未解決の改善項目数が多いプロジェクトがリストされます。',
        title: '残り作業%',
      },
      projectsPastDue: {
        description: '期限が過ぎているプロジェクトの数を示します。',
        subTitle: 'プロジェクト',
        summary: 'は期限を過ぎています',
        title: '期限超過プロジェクト',
      },
      projectsRecentlyClosed: {
        description: '最近クローズされたプロジェクトの数を示します。',
        subTitle: 'プロジェクトクローズド',
        summary: '',
        title: '最近のクローズドプロジェクト',
      },
      remediatedVulnerabilities: {
        description:
          '過去30日以内に環境内で存在数が減少した脆弱性をリストします。',
        title: '上位の改善済み脆弱性',
      },
      remediationProgressCard: {
        assignees: {
          all: 'すべての割り当て先',
          email: '電子メール',
        },
        confirm: '確認',
        dates: {
          all: '常時',
          custom: 'カスタム',
          lastMonth: '先月',
          lastWeek: '先週',
          thisMonth: '今月',
          thisWeek: '今週',
        },
        endDate: '終了日',
        noProjectsCreated: '作成済みプロジェクトなし',
        progress: '進行度',
        projectStatus: {
          complete: '完了',
          completed: '完了',
          inProgress: '進行中',
          incomplete: '未完了',
          notStarted: '未開始',
        },
        projects: 'プロジェクト',
        recentProjects: '最近のプロジェクト',
        startDate: '開始日',
        task: 'タスク',
        title: '改善プロジェクト進行度',
      },
      remediatorsRequiringAssistance: {
        description:
          'オープンのままで期限が過ぎているプロジェクトが多いプロジェクト所有者をリストします。',
        title: '支援が必要な改善実施者',
      },
      'risk-vulns-card': {
        description:
          'リスク別や脆弱性数別でアセットを並べた散布プロット図を示します',
        name: 'リスクおよび脆弱性別のアセット',
      },
      riskOverTimeCard: {
        allTime: '常時',
        custom: 'カスタム',
        riskScore: 'リスクスコア',
        thisMonth: '今月',
        thisWeek: '今週',
        time: '時刻',
        title: '経時的リスク',
      },
      riskVsVulnerabilities: {
        hostname: 'ホスト名：__name__',
        ipAddress: 'IPアドレス',
        riskScore: 'リスクスコア',
        title: 'リスクおよび脆弱性別のアセット',
        vulnerabilities: '脆弱性',
      },
      'scan-card': {
        description:
          '失敗、一時停止、完了したスキャンの数を含む、環境内のすべてのスキャン要旨を示す',
        name: 'スキャン',
      },
      scanCard: {
        complete: '完了',
        drilldownTitle: 'スキャン',
        failed: '不合格',
        inProgress: '進行中',
        paused: '一時停止',
        subTitle: '過去30日間',
        table: {
          assets: 'アセット',
          siteName: 'サイト名',
          startDate: '開始日',
          status: 'ステータス',
          vulnerabilities: '脆弱性',
        },
        title: 'スキャン',
      },
      sites: {
        riskiest: '最高リスクサイト',
        title: '上位の高リスクサイト',
      },
      'top-riskiest-asset-groups': {
        description:
          '環境内でリスク・スコアが最も高いアセット・グループをリストします。',
        name: '上位の高リスクアセット・グループ',
      },
      'top-riskiest-assets': {
        description: '環境内で最も高リスクなアセットをリストします。',
        name: '上位の高リスクアセット',
      },
      'top-riskiest-sites': {
        description: '環境内で総合リスクが最も高いサイトをリストします。',
        name: '上位の高リスクサイト',
      },
      topRemediators: {
        description:
          '期限までに正常にクローズしたプロジェクトが多いプロジェクト所有者をリストします。',
        title: '上位の改善実施者',
      },
      trendingVulnerabilities: {
        description:
          '過去30日以内に環境内で最も見られるようになった脆弱性をリストします。',
        title: '上位のトレンド脆弱性',
      },
      vulnByCVSSScore: {
        description:
          'CVSSスコア別に環境内の脆弱性の内訳パーセントが示され、一般的基準で環境のどの部分のリスクが高いかを確認できます。',
        legend: '__from__-__to__',
        summary: 'の脆弱性のCVSSスコアが__from__と__to__との間',
        title: 'CVSSスコア別の脆弱性',
      },
      vulnByRiskScore: {
        description:
          'リスク・スコア別に環境内のすべての脆弱性のパーセントを示すカード。',
        legend: '__from__-__to__',
        summary: 'の脆弱性のリスク・スコアが__from__と__to__との間',
        summaryOver900: 'の脆弱性のリスク・スコアが900を超える',
        title: 'リスク・スコア別の脆弱性',
      },
      vulnerabilities: {
        ageByCVSS: {
          categories: {
            'age-range-1': '0～29日間',
            'age-range-2': '30～59日間',
            'age-range-3': '60～90日間',
            'age-range-4': '90日間以上',
            'cvss-range-1': '0.1~3.9',
            'cvss-range-2': '4.0~6.9',
            'cvss-range-3': '7.0~10',
          },
          description:
            'CVSSスコア別にランクされた環境内の脆弱性が発見された時期をハイライト表示するカード',
          title: 'CVSSスコア別の脆弱性発見日',
        },
        ageBySeverity: {
          categories: {
            'age-range-1': '0～29日間',
            'age-range-2': '30～59日間',
            'age-range-3': '60～90日間',
            'age-range-4': '90日間以上',
            critical: '危機的',
            moderate: '中度',
            severe: '深刻',
          },
          description: '深刻度別に環境内の脆弱性の平均日齢を示すカード',
          title: '深刻度別の脆弱性平均日齢',
        },
        bySkillLevel: {
          description:
            '環境内の脆弱性の内訳をエクスプロイトに必要なスキルレベル別に示します。',
          expertSummary: 'の脆弱性が上級者によりエクスプロイト可能',
          intermediateSummary: 'の脆弱性が中級者によりエクスプロイト可能',
          legend: {
            expert: '上級者',
            intermediate: '中級者',
            novice: '初心者',
            unknown: '既知のエクスプロイトなし',
          },
          noviceSummary: 'の脆弱性が初心者によりエクスプロイト可能',
          title: 'スキルレベル別のエクスプロイト可能な脆弱性',
          unknownSummary: 'の環境内の脆弱性に既知のエクスプロイトなし',
        },
        bySkillLevelOverTime: {
          description: '経時的深刻度別に環境内のすべての脆弱性を示すカード。',
          title: '経時的スキルレベル別のエクスプロイト可能な脆弱性',
        },
        byVulnSeverity: {
          criticalSummary: 'の脆弱性が危機的',
          description:
            '深刻度レベルに環境内の脆弱性の内訳パーセントを示します。',
          legend: {
            critical: '危機的な脆弱性',
            moderate: '中度な脆弱性',
            severe: '深刻な脆弱性',
            unknown: '未確認',
          },
          moderateSummary: 'の脆弱性が中度',
          severeSummary: 'の脆弱性が深刻',
          title: '危険度別の脆弱性数',
        },
        card: {
          exploitable: {
            description:
              '環境内の脆弱性の合計数および指定時間枠内での数の推移を示すカード。',
            subTitle: 'エクスプロイト可能な脆弱性',
            title: 'エクスプロイト可能な脆弱性カウント',
          },
          totalNumber: {
            description:
              '選択した期間中の環境内の脆弱性の数の変化を示すカード。',
            subTitle: '脆弱性合計',
            summary: ' __difference__（__percentDifference__%変更）',
            title: '脆弱性の数',
          },
        },
        detail: {
          entity: {
            cvssScore: 'CVSS',
            dateModified: '修正',
            datePublished: '公開',
            severity: '深刻度',
            title: 'タイトル',
            vulnId: '脆弱性ID',
          },
          title: '脆弱性情報',
          vulnInstances: {
            dataFetchFailed: '脆弱性インスタンスの検索に失敗しました。',
          },
        },
        discoveryByTotalRiskScore: {
          description:
            '総合リスク・スコア別に、高リスクから低リスクの順に、過去90日間に発見された脆弱性を示します。',
          title: '総合リスク・スコア別の新たに発見された脆弱性',
        },
        discoveryDateBySeverity: {
          categories: {
            'age-range-1': '0～29日間',
            'age-range-2': '30～59日間',
            'age-range-3': '60～90日間',
            'age-range-4': '90日間以上',
            critical: '危機的',
            moderate: '中度',
            severe: '深刻',
          },
          description:
            '深刻度別にランクされた環境内の脆弱性が発見された時期をハイライト表示するカード',
          title: '深刻度別の脆弱性発見日',
        },
        exploitable: {
          ageByCVSS: {
            description:
              'CVSSスコア別にランクされた環境内のエクスプロイト可能な脆弱性が発見された時期をハイライト表示するカード',
            title: 'CVSSスコア別にエクスプロイト可能な脆弱性発見日',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
          ageBySeverity: {
            description:
              '深刻度別に環境内のエクスプロイト可能な脆弱性の平均日齢を示すカード',
            title: '深刻度別にエクスプロイト可能な脆弱性の平均齢',
          },
          byVulnSeverity: {
            criticalSummary: 'のエクスプロイト可能な脆弱性が危機的',
            description:
              '深刻度レベルに環境内のエクスプロイト可能な脆弱性の内訳パーセントを示します。',
            legend: {
              critical: '危機的なエクスプロイト可能な脆弱性',
              moderate: '中度なエクスプロイト可能な脆弱性',
              severe: '深刻なエクスプロイト可能な脆弱性',
              unknown: '未確認',
            },
            moderateSummary: 'のエクスプロイト可能な脆弱性が中度',
            severeSummary: 'のエクスプロイト可能な脆弱性が深刻',
            title: '深刻度別にエクスプロイト可能な脆弱性',
          },
          discoveryByTotalRiskScore: {
            description:
              '総合リスク・スコア別に、高リスクから低リスクの順に、過去90日間に発見されたエクスプロイト可能な脆弱性を示します。',
            title:
              '総合リスク・スコア別の新たに発見されたエクスプロイト可能な脆弱性',
          },
          discoveryDateBySeverity: {
            description:
              '深刻度別にランクされた環境内のエクスプロイト可能な脆弱性が発見された時期をハイライト表示するカード',
            title: '深刻度別のエクスプロイト可能な脆弱性発見日',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishAgeBySeverity: {
            description:
              '深刻度別の環境内のエクスプロイト可能な脆弱性の公開後経過日数を詳しく示すカード',
            title: '深刻度別のエクスプロイト可能な脆弱性の公開後経過日数',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishDateByCVSS: {
            description:
              'CVSSスコア別のエクスプロイト可能な脆弱性の公開日をリストするカード',
            title: 'CVSSスコア別のエクスプロイト可能な脆弱性の公開日',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
        },
        introducedLastWeek: {
          description:
            'リスク・スコア別に先週ネットワークに導入された新規脆弱性を示すカード。',
          title: 'リスク・スコア別の新規脆弱性',
        },
        publishAgeBySeverity: {
          categories: {
            'age-range-1': '0～29日間',
            'age-range-2': '30～59日間',
            'age-range-3': '60～90日間',
            'age-range-4': '90日間以上',
            critical: '危機的',
            moderate: '中度',
            severe: '深刻',
          },
          description:
            '深刻度別の環境内の脆弱性の公開後経過日数を詳しく示すカード',
          title: '深刻度別の脆弱性公開後経過日数',
        },
        publishDateByCVSS: {
          categories: {
            'age-range-1': '0～29日間',
            'age-range-2': '30～59日間',
            'age-range-3': '60～90日間',
            'age-range-4': '90日間以上',
            'cvss-range-1': '0.1~3.9',
            'cvss-range-2': '4.0~6.9',
            'cvss-range-3': '7.0~10',
          },
          description: 'CVSSスコア別の脆弱性の公開日をリストするカード',
          title: 'CVSSスコア別の脆弱性公開日',
        },
        remediated: {
          description:
            'リスク・スコアが最も高いネットワークの改善策をリストを示すカード。',
          title: 'リスク・スコア別の最近の完了済み改善策',
        },
        riskScoreOverTime: {
          cardTitle: '経時的な脆弱性リスク・スコア',
          description:
            '環境内の脆弱性リスクのトレンドが示され、総合リスクの経時的な増減を確認できます。',
          name: '経時的な脆弱性リスク・スコア',
        },
      },
    },
    cardsLabel: 'カード',
    category: 'カテゴリ',
    certainity: '確信度',
    certainty: '確信度',
    chart: {
      loading: 'チャートのロード中。',
      noData: 'このチャートを表示するのに十分なデータがありません。',
    },
    class: 'クラス',
    close: '閉じる',
    closed: 'クローズド',
    comingSoon: '近日提供',
    comparison: {
      cancelText: '比較をキャンセル',
      compare: '比較',
      errorMessage: '比較に有効な日付を2つ選択してください。',
      failedDataFetch: '比較データ取得に失敗しました、後で試行してください。',
      fromDate: '開始日',
      metricAdded: '__name__を追加',
      metricChange: '__name__変更',
      metricPrimarySubTitle: '2つの選択スキャンの__name__合計',
      metricRemediated: '改善済みの__name__',
      metricUnchanged: '未変更の__name__',
      text: '比較 - 2つのスキャンを比較して何が変更されたかを確認',
      toDate: '終了日',
    },
    configure: '設定',
    confirm: 'OK',
    confirmLabel: '確認',
    'container-counts': {
      description: 'アセットコンテナカウントを示すカード',
      name: 'カウント',
    },
    continue: '続行',
    copy: 'コピー',
    count: 'カウント',
    cpe: 'CPE',
    createdOn: '作成日',
    critical: '危機的',
    cvss: 'CVSS',
    cvssScore: 'CVSSスコア',
    dashboard: {
      cannotBeEmpty: 'ダッシュボード名は空白であってはなりません',
      nameInUse: 'この名前はすでに使用されています',
      tooLong: '最大長__length__文字を超えています',
    },
    dashboardDescription: '$t(dashboardLabel) 説明',
    dashboardDropdown: {
      allMyDashboards: 'すべてのMyダッシュボード',
      allTemplates: 'R7ライブラリで詳細を確認',
      createDashboard: '新規ダッシュボードを作成',
      dashboardTemplates:
        'Rapid7はこれらのダッシュボードテンプレートを推奨します',
      myDashboards: 'Myダッシュボード',
    },
    dashboardLabel: 'ダッシュボード',
    dashboardLibrary: {
      categoryName: {
        allMyDashboards: '$t(dashboardDropdown.allMyDashboards)',
        allTemplates: 'すべてのダッシュボードテンプレート',
        asset: 'アセットテンプレート',
        changed: '変更内容テンプレート',
        executive: 'エグゼクティブテンプレート',
        ownedDashboards: '自身による所有',
        scans: 'スキャン&オペレーションテンプレート',
        sharedDashboards: '自身と共有',
        vulnerability: '脆弱性テンプレート',
      },
      dashboardTemplates: 'Rapid7ダッシュボードテンプレート',
      myDashboards: 'Myダッシュボード',
      templateDescription: {
        assets:
          'アセットダッシュボードには、アセットの視認性、属性および脆弱性が記載されており、環境内で最も重要なアセットと脅威露出を素早く発見し理解できます。',
        changed:
          '変更内容ダッシュボードには、変更されたもの、新しく発見されたアセット、およぼベースライン評価基準を判定っする効率的な方法が用意されており、コンテキスト確立に役立ちます。',
        executive:
          '脅威露出が改善／悪化しているかを理解します。チームパフォーマンスや主要基準に関する見解を得て、投資のリターンを抽出します。',
        exploitableVulns:
          'エクスプロイト可能な脆弱性ダッシュボードは、既知のエクスプロイト・キットまたはマルウェアに関連する、脆弱性データの可視性を提供します。',
        petya:
          '本ダッシュボードには、一因として脆弱性をエクスプロイトして広がる (MS17-010)、Petya亜種ランサムウェアのオカレンスを即座に可視化する、カード一式が含まれています。',
        remediations:
          '改善ダッシュボードは、改善作業の可視性を提供し、重要事項に焦点を当てるのに役立ちます：リスクプロジェクトにおいて改善チームは、最高の改善チームであっても支援が必要です。',
        samba:
          'このダッシュボードには、特定の高プロファイル脆弱性:Samba (CVE-2017-7494) の即時可視性を提供する、カード一式が含まれています。これらのカードは、この脆弱性に関する 貴組織のセキュリティ状況についてレポートするため、カスタムフィルターされています。',
        threatFeed:
          '脅威フィードダッシュボードは、Rapid7脅威フィードソースを通して、高度にエクスプロイト可能かつアクティブに追跡・エクスプロイトされる脆弱性データの可視性を提供します。',
        vulnerabilities:
          '脆弱性ダッシュボードでは、脆弱性の有無および性質を確認して、環境内で次に行うべき最重要なアクションを認知できます。',
        wannaCry:
          '本ダッシュボードには、脆弱性をエクスプロイトして広がる (CVE-2017-0144)、WannaCryランサムウェアのオカレンスを即座に可視化する、カード一式が含まれています。これらのカードは、WannaCryに関する 貴組織のセキュリティ状況についてレポートするため、カスタムフィルターされています。',
      },
      templateName: {
        assets: 'アセットダッシュボード',
        changed: '変更内容ダッシュボード',
        executive: 'エグゼクティブダッシュボード',
        exploitableVulns: 'エクスプロイト可能な脆弱性ダッシュボード',
        petya: 'Petya亜種ランサムウェア',
        remediations: '改善ダッシュボード',
        samba: 'Samba',
        threatFeed: '脅威フィードダッシュボード',
        vulnerabilities: '脆弱性ダッシュボード',
        wannaCry: 'WannaCry',
      },
    },
    dashboardLibraryLabel: '$t(dashboardLabel) ライブラリ',
    dashboardName: '$t(dashboardLabel) 名前',
    dashboardsFailed:
      'ダッシュボードの検索に失敗しました、リフレッシュして再試行してください。',
    dashboardsSaveFailed: '警告: ダッシュボードの保存に失敗しました',
    databaseName: 'データベース名',
    databases: 'データベース',
    date: '日付',
    days: '日数',
    defaultDashboard: 'デフォルトダッシュボード',
    defaultDelete: 'デフォルトダッシュボードは削除できません',
    defaultNameChangeAlert: 'デフォルトダッシュボードの名前は変更できません',
    delete: '削除',
    deleteDashboard: '"__dashboardName__"を削除してよろしいですか',
    deleteIconToolTip: 'カードを削除',
    description: '説明',
    details: '詳細',
    deviceClass: 'デバイスクラス',
    disabled: '無効化',
    discoveredByConnection: '接続により発見',
    discoveryDate: '発見日',
    dismiss: '棄却',
    downloadAgent: 'エージェントをダウンロード',
    downloadAgents: 'エージェントをダウンロード',
    downloading: 'ダウンロード中',
    dueOn: '期限日',
    duplicate: '複製',
    duplicateDashboard: '$t(duplicate) $t(dashboardLabel)',
    duplicateWidgetTitle: 'カードを複製',
    dynamic: '動的',
    edit: '編集',
    edited: '編集済み',
    ellipses: '__phrase__...',
    enableLiveMonitoring: 'ライブモニタリングを有効化',
    enabled: '有効化',
    error: 'エラー',
    exceptionScope: '例外範囲',
    exceptions: '例外',
    expandCard: 'カードを拡張',
    expirationTime: '期限日',
    expiresOn: '期限日',
    expiringOn: '期限日',
    exploit: 'エクスプロイト',
    exploitCount: 'エクスプロイトカウント',
    exploitDB: '$t(exploit) DB',
    exploitRank: 'ランク',
    exploitRanks: {
      average: '平均',
      excellent: '非常に卓越',
      good: '良好',
      great: '卓越',
      low: '低',
      manual: '手動',
      normal: '普通',
    },
    exploitableVulnerabilities: 'エクスプロイト可能な脆弱性',
    exploitableVulns: '$t(exploitableVulnerabilities)',
    exploits: 'エクスプロイト',
    exportToCSV: 'CSVにエクスポート',
    exposure: '露出',
    exposureValues: {
      common: '共通',
      favored: '優遇',
      occasional: '時折',
      popular: '一般',
      rare: '稀',
      uncommon: '稀',
      undefined: '未定義',
      unknown: '未確認',
    },
    failed: '失敗',
    false: 'False',
    family: 'ファミリー',
    fileName: 'ファイル名',
    files: 'ファイル',
    filesAndDirectories: 'ファイルおよびディレクトリ',
    filter: {
      asset: {
        addressType: 'アドレスタイプ',
        assetId: 'アセットID',
        assetKey: 'アセット固有の識別子',
        assetType: 'アセットタイプ',
        exploitCount: 'エクスプロイトカウント',
        hostName: '$t(hostName)',
        ipAddress: 'IPアドレス',
        mac: 'MACアドレス',
        malwareCount: 'マルウェアカウント',
        operatingSystem: 'OS',
        riskScore: 'リスクスコア',
        vulnerabilityCount: '脆弱性カウント',
      },
      'asset-group': {
        assets: 'アセット',
        groupId: 'グループID',
        groupName: 'グループ',
        isDynamic: '動的です',
        riskScore: 'リスクスコア',
        vulnerabilities: '脆弱性',
      },
      cardError: {
        actionableCardError:
          'カードロードでエラーがありました。カードを<a class="action reload-card">リロード</a>してください、またはカードを<a class="action delete-card">削除</a>してください。',
        actionableFilterError:
          'カードは関連フィルターにエラーがあるためロードできません。<a class="action reset-card">リセット</a>してデフォルトにするかこのカードを<a class="action delete-card">削除</a>してください。',
        cardError:
          'カードロードでエラーがありました。カードをリロードしてください。またはダッシュボード所有者に連絡してカードをリセットまたは削除してください。',
        filterError:
          '関連するフィルターにエラーがあるため、カードをロードできません。連絡先所有者に連絡して、フィルターをリセットまたは削除してください。',
      },
      filterName: '$t(filterLabel) 名前',
      filterText: '$t(filterLabel) テキスト',
      management: {
        allFilter: 'すべての$t(filters)',
        createError:
          '$t(filterLabel) "__filterName__"の作成中にエラーが発生しました',
        createFilter: '$t(filterLabel) を作成',
        createSuccess: '$t(filterLabel) "__filterName__"が正常に作成されました',
        deleteConfirmation:
          'フィルターを削除すると、リンクされているすべてのカードまたはプロジェクトから削除されます。削除してよろしいですか？',
        deleteError:
          '選択したフィルター削除中にエラーがありました。もう一度試行してください。',
        deleteError_plural:
          '選択のフィルター削除でエラーが発生しました。もう一度試行してください。',
        deleteSavedFilter: '保存済みフィルターを削除',
        deleteSharedOnly:
          'フィルターはすべて共有されているため削除されませんでした。',
        deleteSuccess:
          '$t(filterLabel) は削除されました。また使用していたカードから削除されます。',
        deleteSuccess_plural:
          '__count__ $t(filters) は削除されました。また使用していたカードから削除されます。',
        duplicateFilter: '$t(filterLabel) を複製',
        editFilter: '$t(filterLabel) を編集',
        saveError:
          'フィルター"__filterName__"のアップデートでエラーがありました。もう一度試行してください。',
        saveSuccess:
          '$t(filterLabel) "__filterName__"が正常にアップデートされました。',
      },
      notFound: {
        actionableDescription:
          'このカードに適用されているフィルターは所有者により削除されました。<a class="action reset-card">リセット</a>してデフォルトにするかこのカードを<a class="action delete-card">削除</a>してください',
        description:
          'このカードに適用しがフィルターは所有者により削除されました。連絡先所有者に連絡して、フィルターをアップデートまたは削除してください。',
      },
      os: {
        'attribute.deviceType': 'デバイスタイプ',
        'attribute.operatingSystemDescription': 'OS説明',
        'attribute.product': '製品',
        'attribute.productFamily': '製品ファミリー',
        'attribute.productVendor': '製品ベンダー',
        'attribute.systemArchitecture': 'システムアーキテクチャ',
        'attribute.version': 'バージョン',
        count: 'カウント',
      },
      site: {
        assetCount: 'アセットカウント',
        autoEngineSelectionEnabled: 'エンジン選択有効化',
        criticalVulnerabilityCount: '危機的な脆弱性のカウント',
        dynamic: '動的',
        key: 'キー',
        moderateVulnerabilityCount: '中度な脆弱性のカウント',
        name: '名称',
        riskFactor: 'リスク要因',
        riskScore: 'リスクスコア',
        riskScoreTimestamp: 'リスク・スコア・タイムスタンプ',
        severeVulnerabilityCount: '深刻な脆弱性のカウント',
        siteID: 'サイトID',
      },
    },
    filterLabel: 'フィルター',
    filters: 'フィルター',
    find: '検索',
    fingerprints: 'フィンガープリント',
    firstFound: '発見',
    fix: 'フィックス',
    groups: 'グループ',
    hardware: 'ハードウェア',
    hostName: 'ホスト名',
    hostNames: 'ホスト名',
    hostType: 'ホストタイプ',
    id: 'ID',
    installedSoftware: 'インストール済みのソフトウェア',
    instanceCount: 'インスタンス',
    instances: 'インスタンス',
    ipAddress: 'IPアドレス',
    ipAddresses: 'IPアドレス',
    kpi: 'KPI',
    labels: {
      assetGroups: 'アセット・グループ',
    },
    lastOnline: '最後のオンライン',
    lastScan: '最後のスキャン',
    learnMore: '詳細を見る',
    list: {
      loading: 'リストデータをロード中。',
    },
    liveAssessmentDescription:
      '`エージェントはライブアセスメントとモニタリング<br>プログラムのキーコンポーネントです。エージェントは遠隔アセット上の情報を収集して, スキャンを追加せずに<br>より多くのアセットを追跡できるようにします。',
    loadingIssueTypes: '問題のタイプをロード中',
    location: 'ロケーション',
    macAddress: 'MACアドレス',
    macAddresses: 'MACアドレス',
    malware: 'マルウェア',
    malwareCount: 'マルウェアカウント',
    malwareKit: 'マルウェア・キット',
    malwareKits: 'マルウェア・キット',
    manage: '管理',
    me: 'Me',
    metasploit: 'Metasploit',
    minutes: '分',
    moderate: '中度',
    modifiedDate: '修正日',
    modifiedOn: '修正日',
    name: '名前',
    nameIsRequired: '名前は空白であってはなりません',
    newInstances: '新規インスタンス',
    next: '次へ',
    next6months: '次の6カ月間',
    next7days: '次の7日間',
    next30days: '次の30日間',
    next60days: '次の60日間',
    next90days: '次の90日間',
    nextScan: '次のスキャン',
    nextYear: '来年',
    no: 'いいえ',
    noActiveExploitsAvailable:
      'この脆弱性は現在、アクティブターゲットとしてRapid7により追跡されていません。',
    noOfAssets: 'アセットの数',
    noOfAssetsAffected: '影響を受けるアセットの数',
    noOfInstances: '新規インスタンスの数',
    noRecords: '記録が見つかりません。',
    noWidgets: 'カードが選択されていません。',
    numberOfNumber: '__divisor__ の__dividend__',
    offline: 'オフライン',
    online: 'オンライン',
    onlineSince: '継続オンライン開始日',
    open: 'オープン',
    operatingSystem: 'オペレーティング・システム',
    operatingSystems: 'オペレーティング・システム',
    optional: 'オプション',
    originalRiskScore: '元のリスク・スコア',
    os: {
      products: '__vendor__製品',
      versions: '__vendor__ __product__バージョン',
    },
    osLabel: 'OS',
    other: 'その他',
    overview: '概要',
    owner: '所有者',
    password: 'パスワード',
    past2weeks: '過去2週間',
    past6months: '過去6カ月',
    past7days: '過去7日間',
    past30days: '過去30日間',
    past60days: '過去60日間',
    past90days: '過去90日間',
    pastDue: '期限超過',
    pastMonth: '先月',
    pastWeek: '先週',
    pastYear: '昨年',
    percent: '__percent__$t(percentageSymbol)',
    percentLabel: 'パーセント',
    percentOfAssets: '$t(percentageSymbol) のアセット',
    percentageSymbol: '%',
    petya: 'Petya',
    policies: 'ポリシー',
    policyElement: 'ポリシー要素',
    policyName: 'ポリシー名',
    policyTitle: 'ポリシータイトル',
    port: 'ポート',
    previous: '前へ',
    product: '製品',
    program: 'プログラム',
    projects: 'プロジェクト',
    proof: '証拠',
    protocol: 'プロトコル',
    publishDate: '公開日',
    publishedOn: '公開日',
    queryBuilder: {
      alternateIds: {
        altId: '代替idのID',
        size: '代替idの数',
        source: '代替idソース',
        title: '脆弱性の代替idの集合体',
      },
      asset: {
        agentKey: 'エージェントのキー',
        altips: {
          name: '代替ipsの集合体',
          size: '代替ipsの数',
        },
        altmacs: {
          name: '代替macsの集合体',
          size: '代替macsの数',
        },
        altnames: {
          name: '代替名の集合体',
          size: '代替名の数',
        },
        assetKey: 'アセットのキー',
        averageScanDuration: '平均スキャン時間',
        console: '主要コンソール',
        credentialSuccessStatus: 'ステータスが成功かまたは失敗か',
        endpoints: {
          certainty: 'fpのエンドポイント確信度',
          name: 'エンドポイントサービス名',
          port: 'エンドポイントポート',
          protocol: 'エンドポイントプロトコル',
          size: 'エンドポイントの数',
          title: 'エンドポイントの集合体',
        },
        firstScanTime: '最初のアセットスキャン日',
        groups: 'グループ名の集合体',
        ipv4: 'アセットのメインipv4',
        ipv6: 'アセットのメインipv6',
        lastAgentConnectionTime:
          'エージェントにより行われた最後の接続の日付と時刻。',
        lastScanDuration: '直近のスキャン時間',
        lastScanTime: '直近のアセットスキャン日',
        mac: 'アセットのメインmac',
        name: 'アセットのホスト名',
        os: {
          arch: 'アセットOSアーキテクチャ',
          description: 'アセットOS説明',
          family: 'アセットOSファミリー',
          product: 'アセットOS製品',
          title: 'メインアセットOSオブジェクト',
          type: 'アセットOSタイプ',
          vendor: 'アセットOSベンダー',
          version: 'アセットOSバージョン',
        },
        riskScore: 'アセットリスク・スコア',
        sites: 'サイト名の集合体',
        software: {
          description: 'ソフトウェア説明',
          family: 'ソフトウェアファミリー',
          product: 'ソフトウェア製品',
          program: 'ソフトウェアプログラム',
          size: 'インストール済みソフトウェアの数',
          title: 'ソフトウェアオブジェクトの集合体',
          vendor: 'ソフトウェアベンダー',
          version: 'ソフトウェアバージョン',
        },
        sslCertificateMinimumExpirationDate: 'ssl認証有効期限',
        tags: {
          name: 'タグ名',
          type: 'タグタイプ',
        },
        type: 'アセットのホストタイプ',
      },
      assetgroup: {
        assets: {
          description: 'グループ内のアセット',
          size: 'グループ内のアセットの数',
        },
        dynamic: '静的かまたは動的か',
        groupKey: 'グループの固有ID',
        name: 'アセット・グループ名',
        riskScore: 'グループのリスクスコア',
        vulnCount: '脆弱性の数',
      },
      exploits: {
        description: 'エクスプロイト説明',
        exploitRank: 'エクスプロイト・ランク',
        id: 'エクスプロイトid',
        name: 'エクスプロイト名',
        rank: 'エクスプロイト・ランク',
        size: '脆弱性のエクスプロイトの数',
        source: 'エクスプロイトソース',
        title: '脆弱性が属するエクスプロイトの集合体',
      },
      help: {
        title: 'シンタックスヘルプ／クエリディクショナリ',
      },
      nameIsRequired: '$t(nameIsRequired)',
      placeholder: 'クリックして新規フィルターを作成',
      saveFilter: {
        placeholder: 'フィルターを保存',
        title: 'フィルターを保存',
      },
      selectSavedQuery: '保存したクエリを選択',
      site: {
        assets: {
          description: 'サイト内のアセット',
          size: 'サイト内のアセットの数',
        },
        autoEngineSelected: '自動エンジンステータスかどうか',
        dynamic: '静的かまたは動的か',
        name: 'サイト名',
        riskFactor: 'サイトのリスク要因',
        riskScore: 'サイトのリスクスコア',
        siteKey: 'サイトの固有の識別子',
        status: 'サイトステータス',
        vulnCount: 'サイト内の脆弱性の数',
      },
      solution: {
        fix: '任意脆弱性のソリューションのフィックス',
        solutionKey: '任意脆弱性のソリューションのキー',
        summary: '任意脆弱性のソリューションの要旨',
      },
      tag: {
        assets: {
          description: 'タグ内のアセット',
          size: 'タグ内のアセットの数',
        },
        groups: {
          description: 'タグ内のグループ',
          size: 'タグ内のグループの数',
        },
        name: 'タグの名前',
        riskModifierAttribute: 'タグのリスク修飾因子',
        sites: {
          description: 'タグ内のサイト',
          size: 'タグ内のサイトの数',
        },
        sourceAttribute: 'タグのソース属性',
        tagKey: 'タグの固有の識別子',
        type: 'タグのタイプ',
      },
      type: {
        IP: 'IPアドレス',
        boolean: 'ブーリアン',
        date: '日付',
        duration: '期間',
        object: 'オブジェクト',
        objectCollection: 'オブジェクト集合体',
        standardNumber: '数',
        standardString: 'ストリング',
        stringCollection: 'ストリング集合体',
      },
      vulnerability: {
        assetKey: 'アセットのキー',
        categories: {
          size: 'カテゴリの数',
          title: '脆弱性が属するカテゴリ',
        },
        cveIds: '脆弱性のcve idsのリスト',
        cvssScore: '脆弱性cvssスコア',
        dateModified: '脆弱性が最後に修正された日付',
        datePublished: '脆弱性が公開された日付',
        description: '脆弱性の説明',
        malwareKits: {
          size: 'マルウェア・キットの数',
          title: '脆弱性に関連するマルウェア・キット',
        },
        object: '脆弱性についてのファクトをカプセル封入',
        pciCompliant: 'アセットがPCI準拠であるかどうか',
        port: '脆弱性エンドポイントポート',
        protocol: '脆弱性エンドポイントプロトコル',
        risk: '脆弱性リスク（再スキャンなしでは陳腐化の可能性あり）',
        severity: '脆弱性の深刻度',
        severityScore: '脆弱性の深刻度スコア数値',
        size: '脆弱性の数',
        skillLevel: '脆弱性スキルレベル',
        software: 'ソフトウェアの合成ストリングid',
        softwareFamily: '脆弱性のソフトウェアファミリー',
        softwareProduct: '脆弱性のソフトウェア製品',
        softwareVendor: '脆弱性のソフトウェアベンダー',
        softwareVersion: '脆弱性のソフトウェアバージョン',
        title: '脆弱性タイトル',
        vulnKey: '脆弱性固有の識別子',
      },
      vulnerabilityexception: {
        asset: {
          ipv4: '例外が適用されたアセットのipv4',
          ipv6: '例外が適用されたアセットのipv6',
          key: '例外が定義されたアセットのキー',
          name: '例外が適用されたアセットの名前 ',
          size: 'タグ内のアセットの数',
        },
        expirationTime: '例外の失効時刻',
        port: '例外が定義されたポート',
        reason: '例外の理由',
        reasonDetails: '例外の理由の詳細',
        reviewerActionTime: 'レビューアのアクションの時刻',
        reviewerKey: 'レビューアのキー',
        reviewerReason: 'レビューアアクションの理由',
        scope: '例外の範囲',
        siteKey: '例外が定義されたサイトのキー',
        state: '例外の状態',
        submitterActionTime: '送信者のアクションの時刻',
        submitterKey: '送信者のキー',
        vulnExceptionKey: '脆弱性の例外固有の識別子',
      },
    },
    ra: {
      affectedAssets: '影響を受けるアセット',
      assignees: '割り当て先',
      description:
        '全体的なリスク・スコアに最大の影響を与える、ネットワーク上で実行可能な改善をハイライト表示するカード。',
      project: {
        access: 'アクセス',
        accessDescription:
          '本プロジェクト関連のアセットへのアクセス権を持たないユーザーによる閲覧を許可します',
        assetCountExceeded:
          'プロジェクトあたり__maxAssets__アセットの制限があります。クエリを絞り込んでください。',
        assetFilter: 'アセットフィルター',
        assetSelectionExceeded:
          '静的プロジェクトについては__maxAssets__アセットの制限があります。一部のアセットを非選択にして、もう一度試してください。',
        cardAssetFilter: 'カードアセットフィルター',
        cardVulnerabilityFilter: 'カード脆弱性フィルター',
        chooseConnection: 'プロジェクト接続を選択',
        createProject: '改善プロジェクトを作成',
        deleteError: '改善プロジェクトの削除中にエラーが発生しました。',
        deleteProjectConfirm: '選択したプロジェクトを削除してよろしいですか？',
        deleteProjectTitle: 'プロジェクト削除を確認',
        editProject: '改善プロジェクトを編集',
        entity: {
          assignees: '割り当て先',
          completedAssetsPercent: '%アセット完了',
          completedRemediations: '解決済みソリューション',
          completedRemediationsPercent: '進行度',
          createdOn: '$t(createdOn)',
          description: '説明',
          dueOnTime: '期限日',
          numAssets: '影響を受けるアセット',
          ownerName: '所有者',
          progress: '進行度',
          remainingRemediations: '残り改善策',
          remainingTime: '残り時間',
          remainingWork: '残り作業',
          serverActive: 'チケット',
          status: 'ステータス',
          title: 'プロジェクト名',
          totalRemediations: '改善策合計',
          totalRisk: '累積リスク',
          type: 'タイプ',
        },
        filterPlaceholder: 'クリックしてフィルターを追加',
        minimumDate: '期限日は本日以降でなければなりません。',
        nameInUse: 'この名前はすでに使用されています',
        nameIsRequired: '$t(nameIsRequired)',
        overview: {
          title: 'プロジェクト概要',
        },
        owner: {
          active: '$t(active)',
          email: '電子メール',
          userFullName: '名称',
          userKey: 'ユーザーID',
          userName: 'ユーザー名',
        },
        ownerTitle: 'プロジェクト所有者',
        populatingNoRows:
          '記録が見つかりませんでした。最近作成されたプロジェクトの場合、ソリューションが完全に実装されるまで数分かかることがあります。',
        populatingWarning:
          'プロジェクトが作成されました。プロジェクトにソリューションが完全に実装されるまで、数分かかることがあります。',
        projectContent: 'プロジェクトコンテンツ',
        status: {
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
        },
        ticketingConfigurationWarning: 'ここで行う選択は後で変更できません。',
        type: {
          DYNAMIC: '動的',
          STATIC: '静的',
        },
        updateError: '$t(cards.assets.drilldown.remediation.errorNotification)',
        updateStatusError:
          '改善プロジェクトのアップデート中にエラーが起こりました。',
        updateToClosedStatus: '選択したプロジェクトをクローズ',
        updateToOpenStatus: '選択したプロジェクトをオープン',
        viewProject: 'プロジェクトを表示',
        vulnerabilityFilter: '脆弱性フィルター',
      },
      projectError: {
        entity: {
          description: '説明',
          errorType: 'エラーコード',
          timeOccurred: '日付エラー',
        },
        errorsDescription:
          '改善プロジェクトのチケットにエラーがあります。以下のエラー詳細をご覧ください',
        errorsHeader: '改善ワークフロー__projectName__でのチケットエラー',
        message: {
          BAD_STATE:
            '無効状態 - サーバー__SERVER_NAME__上に改善ステータス__REMEDIATION_STATUS__のマッピングがありません',
          FAIL_COMMENT_1:
            '問題__ISSUE_KEY__ - 中断またはタイムアウトにコメントを追加できませんでした。',
          FAIL_COMMENT_2:
            '問題__ISSUE_KEY__ - 実行エラーにコメントを追加できませんでした。',
          FAIL_ISSUE_1:
            '__ISSUE_KEY__ - 中断またはタイムアウトについて問題を取得できませんでした。',
          FAIL_ISSUE_2:
            '__ISSUE_KEY__ - 実行エラーについて問題を取得できませんでした。',
          FAIL_STATUS_1:
            '__ISSUE_KEY__ - 中断またはタイムアウトについて問題を取得できませんでした。結果として、改善：__REMEDIATION_SOLUTION_NAME__のステータスに同期できません。',
          FAIL_STATUS_2:
            '__ISSUE_KEY__ - 実行エラーについて問題を取得できませんでした。結果として、改善：__REMEDIATION_SOLUTION_NAME__のステータスに同期できません。',
          FAIL_TICKET_1:
            'URL: __URL__を持つ__SERVER_NAME__のチケットサーバー詳細を取得できませんでした。アセット__USER_REMEDIATION_ASSET_NAMES__上のユーザー__USER_NAME__のための改善__REMEDIATION_UUID__のチケットを作成できません。',
          FAIL_TICKET_2:
            '__type__問題 - 中断またはタイムアウトの作成に失敗しました。アセット__USER_REMEDIATION_ASSET_NAMES__上のユーザー__USER_NAME__のための改善__REMEDIATION_UUID__のチケットを作成できません。',
          FAIL_TICKET_3:
            '__type__問題 - 実行エラーの作成に失敗しました。アセット__USER_REMEDIATION_ASSET_NAMES__上のユーザー__USER_NAME__のための改善__REMEDIATION_UUID__のチケットを作成できません。__type__のエラー収集が__ERROR_COLLECTION__を返します。',
          FAIL_TICKET_4:
            '指定フィールドマッピングがあるチケットの作成中にエラーが起こりました。アセット__USER_REMEDIATION_ASSET_NAMES__上のユーザー__USER_NAME__のための改善__REMEDIATION_UUID__のチケットを作成できません。',
          MAX_TICKETS:
            '本プロジェクトのために__MAX_TICKET_NUMBER__チケットが作成されました。これ以上のチケット作成はできません。さらにチケットが必要な場合は、別のプロジェクトを作成してください。',
          SERVER_DETAILS: 'チケットサーバー詳細を検索できません。',
          STATUS_DETAILS:
            'このサーバーのステータスマッピングはありません。改善ステータスをアップデートできません。',
          USER_DETAILS: 'このプロジェクトに割り当てルールはありません。',
        },
      },
      projects: {
        createProject: 'プロジェクトを作成',
        editProject: '改善プロジェクトを編集',
        metrics: {
          numAssignedMeProjects: '自身に割り当て済み',
          numClosedProjects: '$t(closed)',
          numOpenProjects: '$t(open)',
          numOwnedMeProjects: '自身による所有',
          numProjects: '__numProjects__ プロジェクト',
        },
        title: '改善プロジェクト',
      },
      remediation: {
        entity: {
          assigneeName: '割り当て者',
          completedAssets: '完了したアセット',
          numAssets: '影響を受けるアセット',
          riskReduction: 'リスク削減',
          status: 'ステータス',
          summary: 'ソリューション',
          unresolvedVulns: '$t(vulnerabilities)',
        },
        metrics: {
          assigned: '割り当て済み',
          assignedToMe: '自身に割り当て済み',
          numRemediations: '__numRemediations__ソリューション',
          pendingVerification: '検証保留中',
          unassigned: '未割り当て',
          unknownSolutions: '不明ソリューション',
        },
        status: {
          AWAITING_VERIFICATION: '検証待機中',
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
          OPEN_PENDING: 'オープン - 保留中',
          REOPEN: '再オープン',
          WILL_NOT_FIX: 'フィックスなし',
          WILL_NOT_FIX_PENDING: 'フィックスなし - 保留中',
        },
        tableTitle: '改善ソリューション',
        updateError:
          '改善ソリューションのアップデート中にエラーが発生しました。',
        updateStatus: 'アップデートステータス',
      },
      riskScoreImageTitle: 'アセットでのリスク・スコアの増減。',
      solution: {
        entity: {
          additionalInfo: '追加情報',
          fix: 'フィックス',
          solutionId: 'ソリューションID',
          summary: '要旨',
          url: 'URL',
        },
      },
      solutionTitle: '解決法',
      solutions: 'ソリューション',
      summaryInformation: '要旨情報',
      ticketing: {
        addConnection: 'チケット接続を追加',
        addRuleInfo: '新規ルールをクリックしてルールを追加',
        addStatus: '+ステータスを追加',
        assignmentRule: '割り当てルール',
        assignmentRuleDescription:
          '改善詳細からの情報に基づき、チケットの割り当て先に関するルールを作成します。複数のルールを作成し、それらを適用する順序を設定できるようになります。',
        assignmentRules: '割り当てルール',
        assignmentRulesDescription:
          '割り当てルールにより__type__ユーザーにチケットを自動的に割り当てることができます。新規ルールを追加し、以下のルールを再アレンジしてルールセットを優先順位付けします。ルールは、上から下へと優先度の高い順に適用されます。',
        assignmentRulesHeader:
          '__type__プロジェクト__name__の新規割り当てルールを作成',
        automatedTicketing: '自動化チケット',
        automatedTickets: '自動化チケット',
        automatedTicketsNotConfigured: '自動化チケットは設定されていません',
        changeConnection: '接続を変更',
        chooseConnection: 'プロジェクト接続を選択',
        closeWizardWarning:
          'キャンセルしてよろしいですか？ マッピングおよびテンプレートは保存されません。チケット接続のみが保持されます。',
        configurations: '設定',
        configurationsDescription:
          'チケットテンプレート名をクリックして既存の設定を編集します。新規設定ボタンをクリックして新規設定を追加します。',
        configure: '設定',
        configured: '__fieldMappingName__向けに設定',
        configuredWarning:
          '__type__プロジェクト接続は変更できません。異なるチケット設定を使用する場合は、新規プロジェクトを作成してください。',
        connectionSettings: '接続設定',
        createServerWarning: '先に進む前に接続を設定しなければなりません',
        defaultAssignee: 'デフォルト割り当て先',
        deleteConnection: '接続を削除',
        deleteConnectionDisabled:
          'アクティブチケット接続がある改善プロジェクトを所有しています。チケットサーバー接続を削除するには、これらのプロジェクトを削除する必要があります。',
        deleteServerWarning: 'このサーバーを削除してよろしいですか？',
        disabled: '設定済み、無効',
        enabled: '設定済み、有効',
        error: '設定済み、エラー',
        errorsDescription:
          '改善のプロジェクトチケットにエラーがあります。以下のエラー詳細をご覧ください。',
        errorsHeader: '改善ワークフロー__projectName__でのチケットエラー',
        fieldDescription: 'フィールド説明',
        fieldMappingDescription:
          'チケット作成時に設定する値を指定します。シンタックスヘルプには、改善データをチケットに含めるために、使用可能な変数が含まれています。推奨デフォルト値が提供されています。',
        fieldMappingError:
          'フィールドマッピングを保存できませんでした。もう一度試してください。',
        fieldMappingHeader:
          '__type__プロジェクト__name__のフィールドマッピング',
        fieldMappingNoValuesExist: 'この値は必須ですがオプションはありません。',
        fieldMappingRequired:
          '* 各改善ソリューションステータスについて、必ず1つ以上のチケットシステムステータスを選択してください。',
        fieldMappingSuccess: 'フィールドマッピングがアップデートされました。',
        inactiveWarning: 'サーバーを編集するには、必ず有効化してください。',
        integration: '改善チケット統合',
        issueKey: '問題キー',
        issueType: '問題タイプ',
        manageConnections: 'チケット接続を管理',
        newRule: '新規ルール',
        noIssueTypeForProjectKey:
          '別のプロジェクトキーを選択してください。これには問題タイプがありません',
        notConfigured: '設定されていません',
        projectAndFieldMapping:
          'チケットプロジェクトおよびフィールドマッピング',
        projectError:
          '__projectName__プロジェクトに__count__チケットエラーがあります。',
        projectErrorTitle:
          '改善ワークフロー__projectName__での__count__チケットエラー',
        projectKey: 'プロジェクトキー',
        projectKeyDescription: '問題は選択したプロジェクトに作成されます',
        projectName: 'プロジェクト名',
        remediationStatusButtonWarning:
          'このボタンは、選択した改善がすべて同じステータス（オープン／再オープン／待機中／検証のステータス）である場合のみ、有効化されます。',
        replacementString: {
          $ASSET_IP_LIST: 'アセットipsのカンマ区切りリスト。',
          $ASSET_NAME_LIST: 'アセット名のカンマ区切りリスト。',
          $ASSET_OS_LIST: 'アセットosのカンマ区切りリスト。',
          $DUE_ON: '改善プロジェクトの期限日。',
          $PROJ_NAME: 'プロジェクト名。',
          $PROJ_UUID: 'プロジェクトuuid。',
          $SOL_ADDL_INFO: 'ソリューション追加情報。',
          $SOL_FIX: 'ソリューションフィックスステップ',
          $SOL_NAME: 'ソリューション名。',
          $SOL_URL: 'ソリューション参照URL',
          $VULN_ID_LIST: '脆弱性IDリストのカンマ区切りリスト。',
        },
        ruleSetName: 'ルール設定名',
        schemaSettingsDescription:
          ' チケットサーバー内の特定のプロジェクトへの接続を作成します。後に、追加のプロジェクトおよび問題タイプへの接続を作成可能です。',
        schemaSettingsHeader:
          '__name__内のチケットプロジェクトおよび問題タイプに接続する',
        selectStatus: 'ステータスを選択 *',
        serverConnectionAuthenticationError:
          'チケットサーバーへ接続できませんでした。入力したユーザー名およびパスワードが正しいか確認してください。',
        serverConnectionAuthorizationError:
          'チケットサーバーへ接続できませんでした。入力したアカウントがこれらの<a href="https://help.rapid7.com/insightvm/en-us/#Files/Ticketing_integration.html" target="_blank" rel="noopener noreferrer">要件</a>を満たすか確認してください。',
        serverConnectionDeleteError:
          '接続を削除できませんでした。もう一度試行してください。',
        serverConnectionDeleteSuccess: '接続を正常に削除しました。',
        serverConnectionError:
          'サーバー接続を作成できませんでした。もう一度試行してください。',
        serverConnectionInactiveWarning:
          'サーバー接続が保存されましたが、続行するには有効化しなければなりません。',
        serverConnectionSuccess: 'サーバー接続を正常に作成しました。',
        serverCreated: 'チケットサーバーを正常に作成しました',
        serverName: 'サーバー名',
        serverSettingsDescription:
          '__type__などのチケットプログラムのインスタンスへと接続を作成します。',
        serverSettingsDescription2:
          'この3ステップガイドでは、1つの__type__プロジェクトと問題タイプへの接続追加、および設定ルールを説明します。',
        serverSettingsHeader: '__type__チケットサーバーへの接続',
        serverSettingsUserWarning:
          'このフィールドには以下の__type__許可を持つユーザーが必要です：',
        serverSettingsWarning:
          'これにより__type__サーバーへの接続が確立されます。',
        serverSettingsWarning2:
          '改善ワークフロープロジェクトへのチケット接続を関連付けるまで、チケットは生成されません。',
        serviceNowStatusMappingWarning:
          'マッピング前に、ServiceNow内に所望の状態を作成します。',
        servicePickerDescription:
          '設定するにはチケットサービス上ををクリックします',
        servicePickerHeader: 'チケットサーバーを選択して接続を管理します',
        solutionStatus: '改善ソリューションステータス',
        solutionStatusMapping: 'ソリューションステータスマッピング',
        statusMappingDescription:
          'InsightVM内の改善ステータスをそれぞれ、チケットプログラム内のプロジェクトステータスに一致させます。',
        statusMappingError:
          'プロジェクト改善ステータスマッピングを保存できませんでした。もう一度試行してください。',
        statusMappingHeader:
          '__name__のソリューションステータスマッピングを設定',
        statusMappingSuccess: 'ステータスマッピングがアップデートされました。',
        syntaxHelp: 'シンタックスヘルプ',
        templateName: 'チケットテンプレート名',
        ticketingConnection: 'チケット接続',
        ticketingSystemStatus: 'チケットシステムプロジェクトステータス',
        ticketsCreated: '作成済みチケット：__count__',
        type: {
          JIRA: 'JIRA',
          SERVICENOW: 'ServiceNow',
        },
        userMappingDescription:
          'フィルター基準を基にチケット割り当てを決定するルールを作成します。ルールは優先度1から始めて降順に適用されます。チケットがルール基準に満たない場合、デフォルト割り当て先へと割り当てられます。',
        userMappingError:
          'ユーザーマッピングを保存できませんでした。もう一度試してください。',
        userMappingHeader: '__type__プロジェクト__name__の割り当てルールセット',
        userMappingSuccess: 'ユーザーマッピングがアップデートされました。',
        vulnerabilityFilterRequired:
          '有効なチケットがあるプロジェクトには脆弱性フィルターが必要です',
        wizardHeader: 'チケット接続設定',
      },
      title: 'リスク・スコアに影響を与え得る上位の改善策',
      user: {
        userName: 'ユーザー名',
      },
      vulnerabilities: '脆弱性',
    },
    range: '__from__-__to__ __unit__',
    reason: '理由',
    references: '参照',
    refresh: '残りインスタンス',
    reload: 'リロード',
    remainingInstances: '残りインスタンス',
    remediated: '改善済み',
    remediatedInstances: '改善済みのインスタンス',
    remediatedVuln: '改善済みの脆弱性',
    remediation: '改善',
    remediations: '改善策',
    removeWidget: '"__title__"カードを削除しますか？',
    removeWidgetTitle: 'カードを削除',
    renameDashboard: '$t(dashboardLabel)を名前変更',
    reportedBy: 'レポート者',
    required: '必須',
    reset: 'リセット',
    result: '結果',
    reviewStatus: 'レビューステータス',
    risk: 'リスク',
    riskOverTime: '経時的リスク',
    riskScore: '$t(riskScoreLabel): __riskScore__',
    riskScoreDecrease: 'リスク・スコア減',
    riskScoreIncrease: 'リスク・スコア増',
    riskScoreLabel: 'リスクスコア',
    riskScoreReduction: 'リスク・スコア削減',
    riskTrend: 'リスク傾向',
    ruleCompliance: 'ルール・コンプライアンス',
    samba: 'Samba CVE-2017-7494',
    sambaWithCve: '$t(samba) がある',
    save: '保存',
    saveFilter: 'フィルターを保存',
    scan: 'スキャン',
    scanDuration: 'スキャン時間',
    scanEngine: 'スキャン・エンジン',
    scanHistory: 'スキャン履歴',
    scanStatus: 'スキャンステータス',
    score: 'スコア',
    search: '検索',
    seeDetails: '詳細を参照',
    selectAll: 'すべて選択',
    selectAnOption: 'オプションを選択',
    selectNone: 'すべて選択解除',
    selectedCount: '__selected__を選択',
    selectedTableText: '(__selected__ の __total__ を選択)',
    selectionIsEmptyValidation: '選択を行ってください',
    serviceName: 'サービス名',
    services: 'サービス',
    severe: '深刻',
    severity: '深刻度: __severity__',
    severityLabel: '深刻度',
    shareDashboardWith: 'へのアクセスあり',
    shared: '共有',
    sharedWith: '(__count__ $t(user)) と共有',
    sharedWith_plural: '(__count__ $t(users)) と共有',
    site: 'サイト',
    siteName: 'サイト名',
    siteTable: {
      inProgress: 'スキャン進行中',
      notScanned: '未スキャン',
      scanFinishedOn: 'スキャン終了日/時刻',
      scanPausedOn: 'スキャン一時停止日/時刻',
      scheduledScanFinishedOn: 'スケジュール化スキャン終了',
      scheduledScanInProgress: 'スケジュール化スキャン進行中',
      scheduledScanPausedOn: 'スケジュール化スキャン一時停止日/時刻',
    },
    sites: 'サイト',
    size: 'サイズ',
    software: 'ソフトウェア',
    solution: 'ソリューション',
    solutions: 'ソリューション',
    source: 'ソース',
    sourceLink: 'ソースリンク',
    sourceName: 'ソース名',
    sourceType: 'ソースタイプ',
    standardPolicies: '標準ポリシー',
    static: '静的',
    status: 'ステータス',
    stockchart: {
      buttons: {
        all: '全て',
        monthText: '__text__月',
        weekText: '__text__週',
        yearText: '__text__年',
        ytd: '年累計',
      },
    },
    success: '成功',
    successful: '成功',
    summary: '要旨',
    table: {
      errorMessage: '検索に失敗しました、後で試行してください。',
      initialError:
        '表ロードでエラーがありました。後ほど、試行および<a class="action refresh">リロード</a>してください。',
      loading: '表データをロード中。',
    },
    tag: 'タグ',
    taggedAssets: 'タグ付きアセット',
    tags: 'タグ',
    temporalUnit: {
      hours: '時間',
      minutes: '分',
      seconds: '秒',
    },
    threatFeed: '脅威フィード',
    time: '時刻',
    timeSinceLastAssessment: '最後のアセスメントからの期間',
    timeUnits: {
      days: '__count__日',
      days_plural: '__count__日',
      hours: '__count__時間',
      hours_plural: '__count__時間',
      longerThan: "> $t(timeUnits.__timeUnit__, {'count': __time__})",
      minutes: '__count__分',
      minutes_plural: '__count__分',
      months: '__count__月',
      months_plural: '__count__月',
      weeks: '__count__週',
      weeks_plural: '__count__週',
      years: '__count__年',
      years_plural: '__count__年',
    },
    title: 'タイトル',
    totalInstances: 'インスタンス合計',
    totalRiskScore: '総合リスク・スコア',
    totalRiskScoreReduction: 'リスク・スコア削減合計',
    totalVulns: '脆弱性合計',
    trends: 'トレンド',
    true: 'True',
    type: 'タイプ',
    unchanged: '未変更',
    unknown: '不明',
    unknownOS: '$t(unknown) OS',
    unknownOSVendor: '$t(unknown) オペレーティング・システムベンダー',
    updateMessage: '変更を保存しました',
    url: 'URL',
    user: 'ユーザー',
    username: 'ユーザー名',
    users: 'ユーザー',
    usersAndGroups: 'ユーザーおよびグループ',
    vendor: 'ベンダー',
    vendors: 'ベンダー',
    version: 'バージョン',
    vuln: '脆弱性',
    vulnTitle: '脆弱性タイトル',
    vulnerabilities: '脆弱性',
    vulnerabilitiesOverTime: '経時的脆弱性',
    vulnerability: '脆弱性',
    vulnerabilityCount: '$t(vulnerabilities): __vulns__',
    vulnerabilityException: '脆弱性の例外',
    vulnerabilityExceptions: '脆弱性の例外',
    vulnerabilityInstanceStatus: {
      EXCEPTION_VULN_EXPL: '例外脆弱エクスプロイト',
      EXCEPTION_VULN_POTL: '例外脆弱POTL',
      EXCEPTION_VULN_VERS: '例外脆弱バージョン',
      NOT_VULN_DONT_STORE: '非脆弱保存禁止',
      NOT_VULNERABLE: '非脆弱性',
      OVERRIDDEN_VULN_VERS: 'オーバーライド済み脆弱性バージョン',
      SKIPPED_DISABLED: '省略済み無効化',
      SKIPPED_DOS: '省略済みDos',
      SKIPPED_VERS: '省略済みバージョン',
      SUPERSEDED: '廃止',
      UNEXPECTED_ERR: '予期せぬエラー',
      UNKNOWN: '未確認',
      VULNERABLE_EXPL: '脆弱エクスプロイト済み',
      VULNERABLE_POTENTIAL: '脆弱潜在的',
      VULNERABLE_VERS: '脆弱性バージョン',
    },
    vulnerabilityInstances: '脆弱性インスタンス',
    vulnerabilityLabel: '脆弱性',
    vulnerabilityLabels: {
      criticalVulnerability: '危機的な$t(vulnerabilities)',
      moderateVulnerability: '中度な$t(vulnerabilities)',
      severeVulnerability: '深刻な$t(vulnerabilities)',
      trendLine: '$t(vulnerability) 経時的深刻度別の$t(assets)',
      trendLineDescription: '経時的脆弱性トレンドを示すカード。',
    },
    vulnerabilityTitle: '脆弱性名',
    vulnexception: '$t(vulnerabilityException)',
    vulns: '脆弱性',
    vulnsInfo: '脆弱性情報',
    wannaCry: 'WannaCry',
    weekOf: '__week__の週',
    withoutAgents: 'エージェントなし',
    yes: 'はい',
  },
};
